(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5477,1692,7938,1656,944],{

/***/ 47180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2804);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89093);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5434);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _unisearch_common_ui_element_actions_bookmark__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1692);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72145);
/* harmony import */ var _page_info_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3095);
/* harmony import */ var _page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);

var _excluded = ["data", "pageType", "id", "authorName", "authorImage"];

/* eslint-disable @next/next/no-img-element */












var PageInfo = function PageInfo(_ref) {
  var _data$publishDate, _data$totalView, _data$comments;

  var data = _ref.data,
      pageType = _ref.pageType,
      id = _ref.id,
      authorName = _ref.authorName,
      authorImage = _ref.authorImage,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, _excluded);

  var profileInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_1__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_2__/* .authAtom */ .L4);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
    className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().short_info),
    children: [data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "".concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().author), " ").concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().info_item)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default()), {
          src: authorImage || "/favicon.jpg",
          alt: authorName || "author",
          width: 30,
          height: 30
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().text),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().name),
          children: authorName
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().desc),
          children: "Author"
        })]
      })]
    }), data && (data === null || data === void 0 ? void 0 : data.publishDate) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "".concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().date), " ").concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().info_item)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_10__/* .MdCalendarToday */ .kVv, {})
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().text),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().name),
          children: moment__WEBPACK_IMPORTED_MODULE_3___default()((_data$publishDate = data.publishDate) !== null && _data$publishDate !== void 0 ? _data$publishDate : new Date()).format("MMM DD, YYYY")
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().desc),
          children: "Date Published "
        })]
      })]
    }), data && (data === null || data === void 0 ? void 0 : data.totalView) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "".concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().view), " ").concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().info_item)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_10__/* .MdRemoveRedEye */ .FpO, {})
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().text),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().name),
          children: (_data$totalView = data.totalView) !== null && _data$totalView !== void 0 ? _data$totalView : ""
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().desc),
          children: "Views"
        })]
      })]
    }), data && (data === null || data === void 0 ? void 0 : data.comments) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "".concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().comment), " ").concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().info_item)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_10__/* .MdForum */ .Rlc, {})
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().text),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().name),
          children: (data === null || data === void 0 ? void 0 : (_data$comments = data.comments) === null || _data$comments === void 0 ? void 0 : _data$comments.length) || 0
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().desc),
          children: "Comments"
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_unisearch_common_ui_element_actions_bookmark__WEBPACK_IMPORTED_MODULE_5__["default"], {
      referance: pageType,
      referanceId: id ? parseInt(id) : "",
      is_bookmarked: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__/* .isReadingListed */ .uO)(profileInfo, pageType, id)
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PageInfo);

/***/ }),

/***/ 42422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ PlayButtonWithRipple; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30890);
/* harmony import */ var _play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["colorOrange", "medium", "ripple", "small"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var PlayButtonWithRipple = function PlayButtonWithRipple(_ref) {
  var colorOrange = _ref.colorOrange,
      medium = _ref.medium,
      _ref$ripple = _ref.ripple,
      ripple = _ref$ripple === void 0 ? true : _ref$ripple,
      small = _ref.small,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", _objectSpread(_objectSpread({
    className: "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().play_btn), " ").concat(colorOrange ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().orange)) : "", " ").concat(medium ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().medium)) : "", " ").concat(small ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().small)) : "")
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().arrow_right)
    }), ripple && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      className: (_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().ripple_effect)
    })]
  }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PlayButtonWithRipple);

/***/ }),

/***/ 83380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SocialSharingLinks": function() { return /* binding */ SocialSharingLinks; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var next_share__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21818);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89583);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86893);
/* harmony import */ var _social_links_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76300);
/* harmony import */ var _social_links_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_social_links_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);

var _excluded = ["url", "title", "hashtag"];






var SocialSharingLinks = function SocialSharingLinks(_ref) {
  var url = _ref.url,
      title = _ref.title,
      hashtag = _ref.hashtag,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "".concat((_social_links_module_scss__WEBPACK_IMPORTED_MODULE_3___default().social_links_wrapper), " ").concat(props.className),
    style: props.style,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_0__/* .FacebookShareButton */ .Dk, {
      url: url,
      quote: title,
      hashtag: hashtag,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_4__/* .FiFacebook */ .Bsb, {})
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_0__/* .TwitterShareButton */ .B, {
      url: url,
      title: title,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_4__/* .FiTwitter */ .Ccr, {})
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_0__/* .LinkedinShareButton */ .r2, {
      url: url,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_4__/* .FiLinkedin */ .qOw, {})
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_0__/* .WhatsappShareButton */ .N0, {
      url: url,
      title: title,
      separator: ":: ",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaWhatsapp */ .xpo, {})
    })]
  });
};
/* harmony default export */ __webpack_exports__["default"] = (SocialSharingLinks);

/***/ }),

/***/ 49922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TopRankUniCard */
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4730);
/* harmony import */ var _mui_material_Menu__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(32819);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72145);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89093);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86893);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2804);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71285);
/* harmony import */ var _top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _unisearch_common_ui_element_actions_chat_connect__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90312);
/* harmony import */ var _unisearch_common_ui_element_actions_conversation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10534);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);

var _excluded = ["data", "fetchFavUniData"];

















var FavoriteAction = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3609), __webpack_require__.e(5494)]).then(__webpack_require__.bind(__webpack_require__, 25494));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(25494)];
    }
  }
});
var CompareAction = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3609), __webpack_require__.e(6723)]).then(__webpack_require__.bind(__webpack_require__, 76723));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(76723)];
    }
  }
});
var TopRankUniCard = function TopRankUniCard(_ref) {
  var _data$popularCourse, _data$popularCourse2, _data$popularCourse3;

  var data = _ref.data,
      fetchFavUniData = _ref.fetchFavUniData,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_ref, _excluded);

  var profileInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_5__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_1__/* .authAtom */ .L4);
  var route = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null),
      anchorEl = _useState[0],
      setAnchorEl = _useState[1];

  var open = Boolean(anchorEl);

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  }; // console.log(data);


  var link = "/study/".concat(data === null || data === void 0 ? void 0 : data.countrySlug, "/university/").concat(data === null || data === void 0 ? void 0 : data.universitySlug);
  var courseLink = "/study/".concat(data === null || data === void 0 ? void 0 : data.countrySlug, "/university/").concat(data === null || data === void 0 ? void 0 : data.universitySlug, "/courses");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material_Menu__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
      className: "popular_course_dropdown ".concat((_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().popular_course_dropdown)),
      id: "basic-menu",
      anchorEl: anchorEl,
      open: open,
      onClose: handleClose,
      MenuListProps: {
        "aria-labelledby": "basic-button"
      },
      sx: {
        padding: "0px"
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().popular_course_dropdown_wrapper),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dropdown_heading_wrapper),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
            children: "Popular Courses"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_14__/* .FiX */ .q5L, {
            onClick: handleClose
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dropdown_body_wrapper),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("ul", {
            children: data && (data === null || data === void 0 ? void 0 : (_data$popularCourse = data.popularCourse) === null || _data$popularCourse === void 0 ? void 0 : _data$popularCourse.length) > 0 && ((_data$popularCourse2 = data.popularCourse) === null || _data$popularCourse2 === void 0 ? void 0 : _data$popularCourse2.map(function (course, i) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                  className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().course),
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                    className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().course_level),
                    children: course === null || course === void 0 ? void 0 : course.levelName
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    legacyBehavior: true,
                    href: "".concat(link, "/").concat(course === null || course === void 0 ? void 0 : course.courseSlug),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                      className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().course_name),
                      children: course === null || course === void 0 ? void 0 : course.courseName
                    })
                  })]
                })
              }, i);
            }))
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_rank_card),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().favorite_wrapper),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(FavoriteAction, {
          fetchFavUniData: fetchFavUniData,
          referance: "university",
          referanceId: parseInt(data.universityId),
          is_favorite: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .isUniFavorite */ .bt)(profileInfo, data.universityId)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(CompareAction, {
          referance: "university",
          referanceId: parseInt(data.universityId),
          is_compared: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .isUniCompare */ .j1)(profileInfo, data.universityId)
        }), ((route === null || route === void 0 ? void 0 : route.pathname) === "/app/student/favorite" || (route === null || route === void 0 ? void 0 : route.pathname) === "/app/student/favorite/university") && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_unisearch_common_ui_element_actions_chat_connect__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            recieverType: "university",
            uniId: data.universityId
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_unisearch_common_ui_element_actions_conversation__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            email: data.universityMail
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_image_wrapper),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_6___default()), {
          layout: "responsive",
          width: 380,
          height: 175,
          blurDataURL: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/study/country_placeholder.webp"),
          placeholder: "blur",
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().featured_image),
          src: data.featureImageSrc || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
          alt: data.universityName || "University Cover Photo"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_card_top),
        children: [data.rankFrom && parseInt(data.rankFrom) != 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_rank),
          children: ["Rank: ", data.rankingVarying, data.rankFrom, " ", parseInt(data.rankTo) != 0 && " - " + data.rankTo]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
          legacyBehavior: true,
          href: link || "#",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
            className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_logo_wrapper),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_6___default()), {
              width: 92,
              height: 37,
              blurDataURL: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/uni-profile/logo-placeholder.png"),
              placeholder: "blur",
              src: data.logoSrc || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/uni-profile/logo-placeholder.png"),
              alt: "University Logo"
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
          legacyBehavior: true,
          href: link || "#",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
            className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_name),
            children: data.universityName
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("p", {
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_address),
          children: [data.universityType ? (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .upperFirstLetter */ .cK)(data.universityType) : "", " ", "university, Estd ", data.universityEstd]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("p", {
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_address),
          children: [data.cityName, ", ", data.stateName]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_card_bottom),
        children: [data.totalCourse && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_course_link_wrapper),
          children: [((_data$popularCourse3 = data.popularCourse) === null || _data$popularCourse3 === void 0 ? void 0 : _data$popularCourse3.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("button", {
            className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().btn_popular_course),
            id: "basic-button",
            "aria-controls": "basic-menu",
            "aria-haspopup": "true",
            "aria-expanded": open ? "true" : undefined,
            onClick: handleClick,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_14__/* .FiPlus */ .OvN, {}), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
              children: "Popular Courses"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            legacyBehavior: true,
            href: courseLink || "#",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("a", {
              className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_course_link),
              children: ["View All ", data.totalCourse, " Courses"]
            })
          })]
        }), (data === null || data === void 0 ? void 0 : data.overview) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().uni_desc),
          children: data !== null && data !== void 0 && data.overview ? (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .excerpt */ .X1)(data.overview, 150) : ""
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
          className: (_top_rank_uni_card_module_scss__WEBPACK_IMPORTED_MODULE_13___default().footer_btn_wrapper)
        })]
      })]
    })]
  });
};
/* harmony default export */ __webpack_exports__["Z"] = (TopRankUniCard);

/***/ }),

/***/ 47445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StudyBanner": function() { return /* binding */ StudyBanner; }
/* harmony export */ });
/* harmony import */ var _unisearch_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74155);
/* harmony import */ var _unisearch_common_google_ad_top__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56753);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72145);
/* harmony import */ var _unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90705);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _common_page_info__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47180);
/* harmony import */ var _study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58982);
/* harmony import */ var _study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);
/* eslint-disable @next/next/no-img-element */










var StudyBanner = function StudyBanner(_ref) {
  var _pageData$guidepdf, _pageData$guidepdf2, _pageData$featureImag, _pageData$featureImag2;

  var pageData = _ref.pageData,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      linkType = _ref.linkType;
  var arr = ["united-states", "united-kingdom"];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("section", {
    className: "".concat((_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().section_study_banner), " !pt-6"),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_unisearch_common_google_ad_top__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: "lg:mb-[60px]"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().hero_wrapper),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
          className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().hero_content),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("p", {
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().sub_heading),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
              className: "bold",
              children: pageData === null || pageData === void 0 ? void 0 : pageData.referenceColumnName
            }), " ", (pageData === null || pageData === void 0 ? void 0 : pageData.pageContent) && (0,_unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_3__/* .readingTime */ .f6)(pageData.pageContent) || 1, " ", "min read"]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("h1", {
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heading),
            children: pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle
          }), (pageData === null || pageData === void 0 ? void 0 : pageData.pageShortDescription) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().description),
            children: (0,_unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_3__/* .remove_tags */ .AK)(pageData.pageShortDescription)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().breadcrumbs),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
              legacyBehavior: true,
              href: "/",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
                  children: "Home"
                })
              })
            }), " - ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
              legacyBehavior: true,
              href: "/".concat(linkType, "/").concat(name),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("span", {
                  children: [linkType, " ", linkType === "study" ? "in ".concat(arr.includes(name) ? "the" : "") : "", " ", pageData === null || pageData === void 0 ? void 0 : pageData.referenceColumnName]
                })
              })
            }), " - ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("p", {
              className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active),
              children: pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().short_info_desktop_),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_common_page_info__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
              pageType: "page",
              id: pageData === null || pageData === void 0 ? void 0 : pageData.pageId,
              data: pageData,
              authorName: pageData === null || pageData === void 0 ? void 0 : pageData.authorName,
              authorImage: pageData === null || pageData === void 0 ? void 0 : pageData.authorProfileImage
            })
          }), pageData && (pageData === null || pageData === void 0 ? void 0 : pageData.guidepdf) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().button_wrapper),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_unisearch_common__WEBPACK_IMPORTED_MODULE_0__/* .DownloadGuide */ .E6, {
              customClasses: {
                root: "btn-bg"
              },
              fileSrc: pageData === null || pageData === void 0 ? void 0 : (_pageData$guidepdf = pageData.guidepdf) === null || _pageData$guidepdf === void 0 ? void 0 : _pageData$guidepdf.src,
              documentId: parseInt(pageData === null || pageData === void 0 ? void 0 : (_pageData$guidepdf2 = pageData.guidepdf) === null || _pageData$guidepdf2 === void 0 ? void 0 : _pageData$guidepdf2.mediaManagerId),
              documentType: linkType == "study" ? "countryguide" : linkType
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
          className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().image_wrapper),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default()), {
            layout: "responsive",
            width: 500,
            height: 450,
            blurDataURL: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/study/country_placeholder.webp"),
            placeholder: "blur",
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().featured_image),
            src: (pageData === null || pageData === void 0 ? void 0 : (_pageData$featureImag = pageData.featureImage) === null || _pageData$featureImag === void 0 ? void 0 : _pageData$featureImag.src) || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/study/country_placeholder.webp"),
            alt: pageData === null || pageData === void 0 ? void 0 : (_pageData$featureImag2 = pageData.featureImage) === null || _pageData$featureImag2 === void 0 ? void 0 : _pageData$featureImag2.alt
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().bg_soft)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().oval_square),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default()), {
              width: 150,
              height: 150,
              src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/study/ornament.webp"),
              alt: "Ornament"
            })
          })]
        })]
      })]
    })
  });
};
/* harmony default export */ __webpack_exports__["default"] = (StudyBanner);

/***/ }),

/***/ 78589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StudyBannerTwo": function() { return /* binding */ StudyBannerTwo; }
/* harmony export */ });
/* harmony import */ var _unisearch_common_google_ad_top__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56753);
/* harmony import */ var _unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90705);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _common_page_info__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47180);
/* harmony import */ var _study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42817);
/* harmony import */ var _study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);









var StudyBannerTwo = function StudyBannerTwo(_ref) {
  var pageData = _ref.pageData,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      linkType = _ref.linkType;
  var arr = ["united-states", "united-kingdom"];
  var link = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var asPath = link.asPath;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
    className: "".concat((_study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6___default().section_study_banner), " !pt-7"),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_unisearch_common_google_ad_top__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: (_study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6___default().hero_container),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("p", {
          className: (_study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6___default().sub_heading),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
            className: "bold",
            children: pageData === null || pageData === void 0 ? void 0 : pageData.referenceColumnName
          }), " ", (pageData === null || pageData === void 0 ? void 0 : pageData.pageContent) && (0,_unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .readingTime */ .f6)(pageData.pageContent) || 1, " ", "min read"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h1", {
          className: "heading-one",
          children: pageData.pageTitle
        }), (pageData === null || pageData === void 0 ? void 0 : pageData.pageShortDescription) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: (_study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6___default().description),
          children: (0,_unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .remove_tags */ .AK)(pageData.pageShortDescription)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
          className: (_study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6___default().breadcrumbs),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            legacyBehavior: true,
            href: "/",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                children: "Home"
              })
            })
          }), " - ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            legacyBehavior: true,
            href: "/".concat(linkType, "/").concat(name),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("span", {
                children: [linkType, " ", linkType === "study" ? "in ".concat(arr.includes(name) ? "the" : "") : "", " ", pageData === null || pageData === void 0 ? void 0 : pageData.referenceColumnName]
              })
            })
          }), " - ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            className: (_study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6___default().active),
            children: pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle
          })]
        }), asPath !== "/".concat(linkType, "/").concat(name) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: (_study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6___default().short_info_desktop),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_page_info__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              data: pageData
            })
          })
        })]
      })]
    })
  });
};
/* harmony default export */ __webpack_exports__["default"] = (StudyBannerTwo);

/***/ }),

/***/ 96512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ StudyLinks; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modules_study_common_social_sharing_links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83380);
/* harmony import */ var _study_links_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52885);
/* harmony import */ var _study_links_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_study_links_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);




var baseUrl = "https://myunisearch.com";




var StudyLinks = function StudyLinks(_ref) {
  var _pageData$pageMenuGro;

  var pageData = _ref.pageData,
      name = _ref.name,
      linkType = _ref.linkType;
  var link = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  var asPath = link.asPath,
      query = link.query;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("section", {
      className: (_study_links_module_scss__WEBPACK_IMPORTED_MODULE_5___default().section_links),
      children: [asPath === "/study/".concat(name) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_modules_study_common_social_sharing_links__WEBPACK_IMPORTED_MODULE_3__["default"], {
        url: "".concat(baseUrl, "/").concat(linkType, "/").concat(name, "/").concat(pageData === null || pageData === void 0 ? void 0 : pageData.slug),
        title: pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle,
        className: (_study_links_module_scss__WEBPACK_IMPORTED_MODULE_5___default().social_link_wrapper)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_study_links_module_scss__WEBPACK_IMPORTED_MODULE_5___default().links_wrapper),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          className: "container",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: (_study_links_module_scss__WEBPACK_IMPORTED_MODULE_5___default().links_container),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("ul", {
              children: pageData === null || pageData === void 0 ? void 0 : (_pageData$pageMenuGro = pageData.pageMenuGroup) === null || _pageData$pageMenuGro === void 0 ? void 0 : _pageData$pageMenuGro.map(function (menu, i) {
                var pageSlug = menu.pageSlug === menu.referenceColumnName ? name : "".concat(name, "/").concat(menu.pageSlug);
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("li", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    legacyBehavior: true,
                    href: "/".concat(linkType, "/").concat(pageSlug),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                      className: "".concat(asPath === "/".concat(linkType, "/").concat(pageSlug) ? "".concat((_study_links_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)) : ""),
                      children: menu === null || menu === void 0 ? void 0 : menu.pageTitle
                    })
                  })
                }, i);
              })
            })
          })
        })
      })]
    })
  });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (StudyLinks)));

/***/ }),

/***/ 7311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hk": function() { return /* reexport */ study_banner.StudyBanner; },
  "T$": function() { return /* reexport */ study_banner_two.StudyBannerTwo; },
  "aF": function() { return /* reexport */ study_links/* StudyLinks */.a; },
  "xH": function() { return /* reexport */ study_top_rank_two.StudyOverviewTopRankTwo; },
  "mp": function() { return /* reexport */ study_video.StudyVideo; }
});

// UNUSED EXPORTS: StudyAdmissionRequirement, StudyAdmissionSession, StudyOverviewAbout, StudyOverviewTopRank, StudyPostAdmission, StudySpecialization

// EXTERNAL MODULE: ./_modules/study/country/study_banner_two.jsx
var study_banner_two = __webpack_require__(78589);
// EXTERNAL MODULE: ./_modules/study/country/study_banner.jsx
var study_banner = __webpack_require__(47445);
// EXTERNAL MODULE: ./_modules/study/country/study_video.jsx
var study_video = __webpack_require__(40768);
// EXTERNAL MODULE: ./_modules/study/country/study_links.jsx
var study_links = __webpack_require__(96512);
// EXTERNAL MODULE: ./_modules/study/country/study_overview/study_overview_about.jsx
var study_overview_about = __webpack_require__(5986);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/study/common/overview_sec_title/index.jsx






var overview_sec_title_OverviewSecTitle = function OverviewSecTitle(props) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.top_rank_title,
      children: /*#__PURE__*/_jsx("h3", {
        children: props.title
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.top_rank_desc,
      children: /*#__PURE__*/_jsx("p", {
        children: props.description
      })
    })]
  });
};

/* harmony default export */ var overview_sec_title = ((/* unused pure expression or super */ null && (overview_sec_title_OverviewSecTitle)));
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
;// CONCATENATED MODULE: ./_modules/study/common/top_uni_box/index.jsx







var TopUniBox = function TopUniBox(props) {
  return /*#__PURE__*/_jsx("div", {
    className: styles.top_uni,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.top_uni_border,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.image,
        children: /*#__PURE__*/_jsx("img", {
          src: getAssets("assets/images/university-logo.png"),
          alt: "university logo"
        })
      }), /*#__PURE__*/_jsx("a", {
        href: "#",
        children: /*#__PURE__*/_jsx("p", {
          className: styles.name,
          children: "The University of Melbourne"
        })
      }), /*#__PURE__*/_jsx("p", {
        className: styles.estd,
        children: "Public university, Estd 1853"
      }), /*#__PURE__*/_jsx("p", {
        className: styles.location,
        children: "Melbourne, Victoria"
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.links,
        children: [/*#__PURE__*/_jsxs("a", {
          className: styles.popular_courses,
          href: "#",
          children: [/*#__PURE__*/_jsx("span", {
            className: styles.first,
            children: "+"
          }), /*#__PURE__*/_jsx("span", {
            className: styles.last,
            children: "Popular Courses"
          })]
        }), /*#__PURE__*/_jsx("a", {
          className: styles.all_courses,
          href: "#",
          children: "View all 331 Courses \u203A"
        })]
      }), /*#__PURE__*/_jsx("p", {
        className: styles.desc,
        children: "The University of Melbourne was founded by Hugh Culling Eardley Childers in 1853. It is the second oldest university of higher education and research."
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.buttons,
        children: [/*#__PURE__*/_jsx("button", {
          className: styles.first,
          children: "+ Follow"
        }), /*#__PURE__*/_jsxs("a", {
          href: "#",
          className: styles.last,
          children: [/*#__PURE__*/_jsx(IoDocumentTextOutline, {}), /*#__PURE__*/_jsx("span", {
            children: "Download Brochure"
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var top_uni_box = ((/* unused pure expression or super */ null && (TopUniBox)));
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(41548);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(73873);
// EXTERNAL MODULE: ./_modules/study/university/components/uni_thumb_grid_box/index.jsx
var uni_thumb_grid_box = __webpack_require__(32182);
;// CONCATENATED MODULE: ./_modules/study/country/study_overview/study_overview_top_rank.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var StudyOverviewTopRank = function StudyOverviewTopRank(_ref) {
  var universities = _ref.universities;
  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [{
      breakpoint: 1921,
      settings: {
        arrows: false,
        centerMode: false,
        slidesToShow: 4,
        slidesToScroll: 4
      }
    }, {
      breakpoint: 1200,
      settings: {
        arrows: false,
        centerMode: false,
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }, {
      breakpoint: 700,
      settings: {
        arrows: false,
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 500,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }
    }]
  };
  return /*#__PURE__*/_jsx("section", {
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.top_rank,
        children: [/*#__PURE__*/_jsx(OverviewSecTitle, {
          title: "Top Universities & Colleges in Australia - Ranking, Fees & Requirement",
          description: "A total of 420501 international students enrolled in 140 higher education institutions in Australia across various courses. The major highlights are shown below"
        }), /*#__PURE__*/_jsx("div", {
          className: "".concat(styles.top_box_container, " top-box-container"),
          children: /*#__PURE__*/_jsx(Slider, _objectSpread(_objectSpread({}, settings), {}, {
            children: universities === null || universities === void 0 ? void 0 : universities.slice(0, 10).map(function (university, i) {
              var _university$country, _university$featuredI, _university$featuredI2, _university$logo, _university$logo2, _university$city, _university$state, _university$country2, _university$country3;

              return /*#__PURE__*/_jsx(UniThumbGridBox, {
                universityLink: "/study/".concat(university === null || university === void 0 ? void 0 : (_university$country = university.country) === null || _university$country === void 0 ? void 0 : _university$country.slug, "/university/").concat(university === null || university === void 0 ? void 0 : university.slug),
                name: university === null || university === void 0 ? void 0 : university.name,
                featuredImage: university === null || university === void 0 ? void 0 : (_university$featuredI = university.featuredImage) === null || _university$featuredI === void 0 ? void 0 : _university$featuredI.src,
                featuredImageAlt: university === null || university === void 0 ? void 0 : (_university$featuredI2 = university.featuredImage) === null || _university$featuredI2 === void 0 ? void 0 : _university$featuredI2.alt,
                logo: university === null || university === void 0 ? void 0 : (_university$logo = university.logo) === null || _university$logo === void 0 ? void 0 : _university$logo.src,
                logoAlt: university === null || university === void 0 ? void 0 : (_university$logo2 = university.logo) === null || _university$logo2 === void 0 ? void 0 : _university$logo2.alt,
                address: university === null || university === void 0 ? void 0 : university.address,
                city: (university === null || university === void 0 ? void 0 : (_university$city = university.city) === null || _university$city === void 0 ? void 0 : _university$city.name) || "City",
                state: (university === null || university === void 0 ? void 0 : (_university$state = university.state) === null || _university$state === void 0 ? void 0 : _university$state.name) || "State",
                country: (university === null || university === void 0 ? void 0 : (_university$country2 = university.country) === null || _university$country2 === void 0 ? void 0 : _university$country2.name) || "Country",
                universityType: university.universityType,
                estd: university === null || university === void 0 ? void 0 : university.estd,
                courseLink: "/study/".concat(university === null || university === void 0 ? void 0 : (_university$country3 = university.country) === null || _university$country3 === void 0 ? void 0 : _university$country3.slug, "/university/").concat(university === null || university === void 0 ? void 0 : university.slug, "/courses"),
                courseNumber: university.course.length
              }, university.id);
            })
          }))
        })]
      })
    })
  });
};
/* harmony default export */ var study_overview_top_rank = ((/* unused pure expression or super */ null && (StudyOverviewTopRank)));
// EXTERNAL MODULE: ./_modules/study/country/study_overview/study_top_rank_two.jsx
var study_top_rank_two = __webpack_require__(5329);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./_modules/study/country/study_overview/study_admission_session.module.scss
var study_admission_session_module = __webpack_require__(20639);
var study_admission_session_module_default = /*#__PURE__*/__webpack_require__.n(study_admission_session_module);
;// CONCATENATED MODULE: ./_modules/study/country/study_overview/study_admission_session.jsx







var colorClasses = [(study_admission_session_module_default()).green, (study_admission_session_module_default()).violet, (study_admission_session_module_default()).blue, (study_admission_session_module_default()).pink, (study_admission_session_module_default()).orange];
var StudyAdmissionSession = function StudyAdmissionSession(_ref) {
  var _countryData$admissio;

  var countryInfo = _ref.countryInfo,
      countryData = _ref.countryData;
  return /*#__PURE__*/_jsx("section", {
    className: styles.section_admission_session,
    children: /*#__PURE__*/_jsxs("div", {
      className: "container",
      children: [/*#__PURE__*/_jsxs("h2", {
        className: styles.title,
        children: ["Intake Dates and Academic Timelines", " ", countryInfo !== null && countryInfo !== void 0 && countryInfo.name ? /*#__PURE__*/_jsxs(_Fragment, {
          children: ["(", countryNameHelper(countryInfo), ")"]
        }) : ""]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.admission_session_wrapper,
        children: /*#__PURE__*/_jsxs("ul", {
          children: [/*#__PURE__*/_jsx("img", {
            className: styles.line,
            src: getAssets("assets/images/study/Line.png"),
            alt: "Line"
          }), countryData === null || countryData === void 0 ? void 0 : (_countryData$admissio = countryData.admissionSessionTimeline) === null || _countryData$admissio === void 0 ? void 0 : _countryData$admissio.map(function (item, i) {
            var _item$icon, _item$icon2;

            return /*#__PURE__*/_jsx(Fragment, {
              children: (item === null || item === void 0 ? void 0 : item.icon) !== null && /*#__PURE__*/_jsxs("li", {
                className: "relative",
                children: [/*#__PURE__*/_jsx("span", {
                  className: "uni-tooltip ".concat(styles.admission_tooltip),
                  children: item === null || item === void 0 ? void 0 : item.description
                }), /*#__PURE__*/_jsx("div", {
                  className: "".concat(styles.icon_wrapper, " ").concat(colorClasses[i]),
                  children: /*#__PURE__*/_jsx("div", {
                    className: styles.icon_image_wrapper,
                    children: /*#__PURE__*/_jsx("img", {
                      src: item === null || item === void 0 ? void 0 : (_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.src,
                      alt: item === null || item === void 0 ? void 0 : (_item$icon2 = item.icon) === null || _item$icon2 === void 0 ? void 0 : _item$icon2.alt
                    })
                  })
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.admission_text,
                  children: item === null || item === void 0 ? void 0 : item.name
                })]
              })
            }, i);
          })]
        })
      })]
    })
  });
};
/* harmony default export */ var study_admission_session = ((/* unused pure expression or super */ null && (StudyAdmissionSession)));
// EXTERNAL MODULE: ./_modules/study/country/study_overview/study_admission_requirement.jsx
var study_admission_requirement = __webpack_require__(56083);
// EXTERNAL MODULE: ./_modules/study/country/study_overview/study_post_admission.jsx
var study_post_admission = __webpack_require__(87872);
// EXTERNAL MODULE: ./_modules/study/country/study_overview/study_specialization.jsx
var study_specialization = __webpack_require__(16235);
;// CONCATENATED MODULE: ./_modules/study/country/study_overview/index.js












/***/ }),

/***/ 56083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StudyAdmissionRequirement": function() { return /* binding */ StudyAdmissionRequirement; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85014);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91655);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79072);
/* harmony import */ var _study_admission_requirement_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68337);
/* harmony import */ var _study_admission_requirement_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_study_admission_requirement_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72145);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);










var StudyAdmissionRequirement = function StudyAdmissionRequirement(_ref) {
  var countryInfo = _ref.countryInfo;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      data = _useState[0],
      setData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      error = _useState3[0],
      setError = _useState3[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setLoading(true);
                _context.next = 4;
                return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/public/country/admission-requirements/".concat(countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.countryId));

              case 4:
                res = _context.sent;
                setLoading(false);
                setData(res.data);
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                setLoading(false);
                setError("Something went wrong");

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
  }, [countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.countryId]);

  var LoadingComponent = function LoadingComponent() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        variant: "rectangular",
        width: "30%",
        height: 30,
        sx: {
          margin: "10px auto"
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        variant: "rectangular",
        width: "50%",
        height: 50,
        sx: {
          margin: "20px auto"
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        container: true,
        spacing: 3,
        alignItems: "center",
        children: [1, 2, 3, 4, 5, 6, 7, 8].map(function (_, i) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
            item: true,
            xs: 12,
            sm: 12,
            md: 4,
            lg: 3,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
              variant: "rectangular",
              width: "100%",
              height: 200
            })
          }, i);
        })
      })]
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: data && (data === null || data === void 0 ? void 0 : data.length) > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("section", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "container",
        children: loading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(LoadingComponent, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: (_study_admission_requirement_module_scss__WEBPACK_IMPORTED_MODULE_8___default().wrapper),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: (_study_admission_requirement_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heading_wrapper),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("h2", {
              children: ["Admission Requirements", " ", countryInfo !== null && countryInfo !== void 0 && countryInfo.name ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                children: ["(", (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .countryNameHelper */ .W6)(countryInfo), ")"]
              }) : ""]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("p", {
              children: ["Here are the major requirements to study in", " ", countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.name, " which you need to ensure while applying to a ", countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.name, " university:"]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("ul", {
            className: (_study_admission_requirement_module_scss__WEBPACK_IMPORTED_MODULE_8___default().requirement_lists),
            children: data === null || data === void 0 ? void 0 : data.map(function (item, i) {
              var _item$icon, _item$icon2;

              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("li", {
                children: [(item === null || item === void 0 ? void 0 : item.icon) !== null && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                  className: (_study_admission_requirement_module_scss__WEBPACK_IMPORTED_MODULE_8___default().icon_wrapper),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
                    src: item === null || item === void 0 ? void 0 : (_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.src,
                    alt: item === null || item === void 0 ? void 0 : (_item$icon2 = item.icon) === null || _item$icon2 === void 0 ? void 0 : _item$icon2.alt
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                  className: (_study_admission_requirement_module_scss__WEBPACK_IMPORTED_MODULE_8___default().desc),
                  children: item === null || item === void 0 ? void 0 : item.specializationName
                })]
              }, i);
            })
          })]
        })
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {})
  });
};
/* harmony default export */ __webpack_exports__["default"] = (StudyAdmissionRequirement);

/***/ }),

/***/ 5986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StudyOverviewAbout": function() { return /* binding */ StudyOverviewAbout; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85014);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91655);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(79072);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72145);
/* harmony import */ var _unisearch_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74155);
/* harmony import */ var _study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(62206);
/* harmony import */ var _study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _unisearch_common_advertisement__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72275);
/* harmony import */ var _unisearch_common_advertisement_row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75693);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);



/* eslint-disable react/jsx-no-target-blank */












var StudyOverviewAbout = function StudyOverviewAbout(_ref) {
  var _pageData$guidepdf, _pageData$guidepdf2, _pageData$guidepdf3;

  var countryInfo = _ref.countryInfo,
      pageData = _ref.pageData;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}),
      data = _useState[0],
      setData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      error = _useState3[0],
      setError = _useState3[1];

  var arr = ["united-states", "united-kingdom"];
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setLoading(true);
                _context.next = 4;
                return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/public/country/info/".concat(countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.slug));

              case 4:
                res = _context.sent;
                setLoading(false);
                setData(res.data);
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                setLoading(false);
                setError("Something went wrong");

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
  }, [countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.slug]);

  var LoadingComponent = function LoadingComponent() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        variant: "rectangular",
        width: "30%",
        height: 30,
        sx: {
          margin: "10px auto"
        }
      }), new Array(4).fill(1).map(function (_, i) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
          variant: "rectangular",
          width: "100%",
          height: 20,
          sx: {
            margin: "10px 0px"
          }
        }, i);
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
        container: true,
        spacing: 2,
        alignItems: "center",
        children: new Array(8).fill(1).map(function (_, i) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
            item: true,
            xs: 12,
            sm: 12,
            md: 4,
            lg: 3,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
              variant: "rectangular",
              width: "100%",
              height: 150
            })
          }, i);
        })
      })]
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .isEmpty */ .xb)(data) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("section", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: "container",
        children: loading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(LoadingComponent, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().heading),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("h2", {
              children: ["About the Country", " ", countryInfo !== null && countryInfo !== void 0 && countryInfo.name ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
                children: ["(", (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .countryNameHelper */ .W6)(countryInfo), ")"]
              }) : ""]
            }), (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
              className: "".concat((_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().country_description), " from_texteditor_wrapper "),
              children: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .htmlParse */ .QA)(data === null || data === void 0 ? void 0 : data.description)
            }), pageData && (pageData === null || pageData === void 0 ? void 0 : pageData.guidepdf) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
              className: "".concat((_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().btn_wrapper), " mb-8"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_unisearch_common__WEBPACK_IMPORTED_MODULE_4__/* .DownloadGuide */ .E6, {
                customClasses: {
                  root: "btn-bg"
                },
                fileSrc: pageData === null || pageData === void 0 ? void 0 : (_pageData$guidepdf = pageData.guidepdf) === null || _pageData$guidepdf === void 0 ? void 0 : _pageData$guidepdf.src,
                fileName: (pageData === null || pageData === void 0 ? void 0 : (_pageData$guidepdf2 = pageData.guidepdf) === null || _pageData$guidepdf2 === void 0 ? void 0 : _pageData$guidepdf2.mediaName) || "Country brochure",
                documentId: parseInt(pageData === null || pageData === void 0 ? void 0 : (_pageData$guidepdf3 = pageData.guidepdf) === null || _pageData$guidepdf3 === void 0 ? void 0 : _pageData$guidepdf3.mediaManagerId),
                documentType: "countryguide"
              })
            })]
          }),  false && /*#__PURE__*/0, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
            className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().about),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("ul", {
              className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().about_facts),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("li", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                  width: 70,
                  height: 70,
                  src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getAssets */ .Vh)("/assets/images/study/capital.webp"),
                  alt: "Capital"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                  className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().first),
                  children: "Capital"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                  className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().last),
                  children: data === null || data === void 0 ? void 0 : data.capital
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("li", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                  width: 70,
                  height: 70,
                  src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getAssets */ .Vh)("/assets/images/study/population.webp"),
                  alt: "Population"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                  className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().first),
                  children: "Population"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("span", {
                  className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().last),
                  children: [data === null || data === void 0 ? void 0 : data.population, " Mn"]
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("li", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                  width: 70,
                  height: 70,
                  src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getAssets */ .Vh)("/assets/images/study/language.webp"),
                  alt: "Language"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                  className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().first),
                  children: "Language"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                  className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().last),
                  children: data === null || data === void 0 ? void 0 : data.language
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("li", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                  width: 70,
                  height: 70,
                  src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getAssets */ .Vh)("/assets/images/study/international-study.webp"),
                  alt: "International Students"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                  className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().first),
                  children: "International Students"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                  className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().last),
                  children: data === null || data === void 0 ? void 0 : data.intStudent
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("li", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                  width: 70,
                  height: 70,
                  src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getAssets */ .Vh)("/assets/images/study/GDP.webp"),
                  alt: "GDP"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                  className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().first),
                  children: "GDP"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("span", {
                  className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().last),
                  children: [data === null || data === void 0 ? void 0 : data.currencySymbol, data === null || data === void 0 ? void 0 : data.gdp, " Trillion"]
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("li", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                  width: 70,
                  height: 70,
                  src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getAssets */ .Vh)("/assets/images/study/click.webp"),
                  alt: "Dialing Code"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                  className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().first),
                  children: "Dialing Code"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                  className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().last),
                  children: data === null || data === void 0 ? void 0 : data.phoneCode
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("li", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                  width: 70,
                  height: 70,
                  src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getAssets */ .Vh)("/assets/images/study/money.webp"),
                  alt: "Currency"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                  className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().first),
                  children: "Currency"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                  className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().last),
                  children: data === null || data === void 0 ? void 0 : data.currency
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("li", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                  width: 70,
                  height: 70,
                  src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getAssets */ .Vh)("/assets/images/study/university.webp"),
                  alt: "Universities"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                  className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().first),
                  children: "Universities"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                  className: (_study_overview_about_module_scss__WEBPACK_IMPORTED_MODULE_12___default().last),
                  children: data === null || data === void 0 ? void 0 : data.noOfUniversity
                })]
              })]
            })
          })]
        })
      })
    })
  });
};
/* harmony default export */ __webpack_exports__["default"] = (StudyOverviewAbout);

/***/ }),

/***/ 87872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StudyPostAdmission": function() { return /* binding */ StudyPostAdmission; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(79072);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72145);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85014);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89093);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86893);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73873);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41548);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2804);
/* harmony import */ var _study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(80512);
/* harmony import */ var _study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















function NextArrow(props) {
  var className = props.className,
      style = props.style,
      onClick = props.onClick;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_12__/* .FiChevronRight */ .Tfp, {
    className: "".concat(className, " InstructionGallerySliderNext"),
    onClick: onClick
  });
}

function PrevArrow(props) {
  var className = props.className,
      style = props.style,
      onClick = props.onClick;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_12__/* .FiChevronLeft */ .YFh, {
    className: "".concat(className, " InstructionGallerySliderPrev"),
    onClick: onClick
  });
}

var settings = {
  dots: false,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 4000,
  infinite: true,
  speed: 700,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerPadding: "60px",
  nextArrow: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(NextArrow, {}),
  prevArrow: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(PrevArrow, {}),
  responsive: [{
    breakpoint: 900,
    settings: {
      arrows: true,
      centerMode: false,
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 600,
    settings: {
      arrows: true,
      dots: false,
      centerMode: false,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
};
var StudyPostAdmission = function StudyPostAdmission(_ref) {
  var countryInfo = _ref.countryInfo;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  var query = router.query;
  var weatherAtomState = (0,recoil__WEBPACK_IMPORTED_MODULE_10__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_4__/* .weatherAtom */ .R);
  var setWeather = (0,recoil__WEBPACK_IMPORTED_MODULE_10__/* .useSetRecoilState */ .Zl)(_recoil_state__WEBPACK_IMPORTED_MODULE_4__/* .weatherAtom */ .R);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]),
      visaData = _useState[0],
      setVisaData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]),
      costData = _useState2[0],
      setCostData = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      loading = _useState3[0],
      setLoading = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""),
      error = _useState4[0],
      setError = _useState4[1]; // fetch visa data


  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
        var res;
        return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setLoading(true);
                _context.next = 4;
                return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/public/country/visa-options/".concat(countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.countryId));

              case 4:
                res = _context.sent;
                setLoading(false);
                setVisaData(res.data);
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                setLoading(false);
                setError("Something went wrong");

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
  }, [countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.countryId]); // fetch living cost data

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2() {
        var res;
        return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                setLoading(true);
                _context2.next = 4;
                return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/public/country/living-cost/".concat(countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.countryId));

              case 4:
                res = _context2.sent;
                setLoading(false);
                setCostData(res.data);
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                setLoading(false);
                setError("Something went wrong");

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 9]]);
      }));

      return function fetchData() {
        return _ref3.apply(this, arguments);
      };
    }();

    fetchData();
  }, [countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.countryId]);

  var handleChange = function handleChange(e) {
    setWeather(function (curVal) {
      return _objectSpread(_objectSpread({}, curVal), {}, {
        currentMonth: e.target.value
      });
    });
  };

  var fetchWeatherData = /*#__PURE__*/function () {
    var _ref4 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3() {
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/public/weather?country=".concat(weatherAtomState.countryName, "&month=").concat(weatherAtomState.currentMonth)).then(function (resp) {
                if (!resp.error) {
                  setWeather(function (curVal) {
                    return _objectSpread(_objectSpread({}, curVal), {}, {
                      weatherData: resp.data
                    });
                  });
                }
              })["catch"](function (e) {});

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function fetchWeatherData() {
      return _ref4.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    setWeather(function (curVal) {
      return _objectSpread(_objectSpread({}, curVal), {}, {
        countryName: query.country_name
      });
    });
  }, [query.country_name]);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    if (weatherAtomState.countryName && weatherAtomState.countryName != "") {
      fetchWeatherData();
    }
  }, [weatherAtomState.countryName, weatherAtomState.currentMonth]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("section", {
    className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().section_post_admission),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("h2", {
        className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().heading),
        children: ["Living in", " ", countryInfo !== null && countryInfo !== void 0 && countryInfo.name ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
          children: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .countryNameHelper */ .W6)(countryInfo)
        }) : ""]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().post_admission_wrapper),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
          container: true,
          spacing: {
            xs: 0,
            sm: 0,
            md: 5
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
            item: true,
            md: 6,
            sm: 12,
            xs: 12,
            children: [(visaData === null || visaData === void 0 ? void 0 : visaData.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: "visa-option-slider",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: "".concat((_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().sub_title), " ").concat((_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().visa_option)),
                children: ["Visa Options", " ", countryInfo !== null && countryInfo !== void 0 && countryInfo.name ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
                  children: ["(", (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .countryNameHelper */ .W6)(countryInfo), ")"]
                }) : ""]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_7__["default"], _objectSpread(_objectSpread({}, settings), {}, {
                children: visaData.map(function (visa, i) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                    className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().card_wrapper),
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                      className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().card_title),
                      children: visa === null || visa === void 0 ? void 0 : visa.visaTitle
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                      className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().quick_info_wrapper),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("span", {
                        children: ["Cost - ", countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.currencySymbol, visa === null || visa === void 0 ? void 0 : visa.visaFee]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("span", {
                        children: ["Type - ", visa === null || visa === void 0 ? void 0 : visa.visaType]
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
                      className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().card_description),
                      children: visa === null || visa === void 0 ? void 0 : visa.description
                    })]
                  });
                })
              }))]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().costof_living_wrapper),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().sub_title),
                children: ["Cost of Living", " ", countryInfo !== null && countryInfo !== void 0 && countryInfo.name ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
                  children: ["(", (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .countryNameHelper */ .W6)(countryInfo), ")"]
                }) : ""]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().low_high_indicator_wrapper),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().low_high_image_wrapper),
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
                    src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/study/low_high_indicator_wheel.png"),
                    alt: "Low High Indicator Wheel"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
                    className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().low_high_indicator),
                    src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/study/low_high_indicator.png"),
                    alt: "Low High Indicator"
                  })]
                })
              })]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
            item: true,
            md: 6,
            sm: 12,
            xs: 12,
            children: [weatherAtomState.weatherData.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().weather_box_wrapper),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().weather_heading),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().sub_title),
                  children: ["Weather", " ", countryInfo !== null && countryInfo !== void 0 && countryInfo.name ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
                    children: ["(", (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .countryNameHelper */ .W6)(countryInfo), ")"]
                  }) : ""]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().select_dropdown_wrapper),
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("select", {
                    value: weatherAtomState.currentMonth,
                    onChange: handleChange,
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("option", {
                      value: "January",
                      children: "January"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("option", {
                      value: "February",
                      children: "February"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("option", {
                      value: "March",
                      children: "March"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("option", {
                      value: "April",
                      children: "April"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("option", {
                      value: "May",
                      children: "May"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("option", {
                      value: "June",
                      children: "June"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("option", {
                      value: "July",
                      children: "July"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("option", {
                      value: "August",
                      children: "August"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("option", {
                      value: "September",
                      children: "September"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("option", {
                      value: "October",
                      children: "October"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("option", {
                      value: "November",
                      children: "November"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("option", {
                      value: "December",
                      children: "December"
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
                    children: "C\xB0"
                  })]
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("ul", {
                className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().weather_list),
                children: weatherAtomState.weatherData.map(function (weather, i) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("li", {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                      className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().city),
                      children: weather.name
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("span", {
                      className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().temperature),
                      children: [weather.minTemp, "\xB0 ~ ", weather.maxTemp, "\xB0"]
                    })]
                  }, i);
                })
              })]
            }), (costData === null || costData === void 0 ? void 0 : costData.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().living_cost_wrapper),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().sub_title),
                children: ["Monthly Living Expenses", " ", countryInfo !== null && countryInfo !== void 0 && countryInfo.name ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
                  children: ["(", (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .countryNameHelper */ .W6)(countryInfo), ")"]
                }) : ""]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("ul", {
                className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().living_cost_list),
                children: costData === null || costData === void 0 ? void 0 : costData.map(function (cost, i) {
                  var _cost$icon, _cost$icon2;

                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
                    children: (cost === null || cost === void 0 ? void 0 : cost.icon) !== null && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("li", {
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                        className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().cost_image),
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("img", {
                          src: cost === null || cost === void 0 ? void 0 : (_cost$icon = cost.icon) === null || _cost$icon === void 0 ? void 0 : _cost$icon.src,
                          alt: (cost === null || cost === void 0 ? void 0 : (_cost$icon2 = cost.icon) === null || _cost$icon2 === void 0 ? void 0 : _cost$icon2.alt) || "Alt text"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                        className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().cost_title),
                        children: cost === null || cost === void 0 ? void 0 : cost.livingCostName
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                        className: (_study_post_admission_module_scss__WEBPACK_IMPORTED_MODULE_14___default().cost_range),
                        children: [countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.currencySymbol, cost === null || cost === void 0 ? void 0 : cost.amountFrom, "-", countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.currencySymbol, cost === null || cost === void 0 ? void 0 : cost.amountTo]
                      })]
                    })
                  }, i);
                })
              })]
            })]
          })]
        })
      })]
    })
  });
};
/* harmony default export */ __webpack_exports__["default"] = (StudyPostAdmission);

/***/ }),

/***/ 16235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StudySpecialization": function() { return /* binding */ StudySpecialization; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85014);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79072);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91655);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _study_specialization_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71921);
/* harmony import */ var _study_specialization_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_study_specialization_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);











var StudySpecialization = function StudySpecialization() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      data = _useState[0],
      setData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      error = _useState3[0],
      setError = _useState3[1];

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)(),
      query = _useRouter.query;

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setLoading(true);
                _context.next = 4;
                return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/public/specialization");

              case 4:
                res = _context.sent;
                setLoading(false);
                setData(res.data);
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                setLoading(false);
                setError("Something went wrong");

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchData();
  }, []);

  var LoadingComponent = function LoadingComponent() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        container: true,
        spacing: 2,
        alignItems: "center",
        children: [1, 2, 3, 4, 5, 6, 7, 8].map(function (_, i) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
            item: true,
            xs: 12,
            sm: 12,
            md: 4,
            lg: 3,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              variant: "circular",
              width: 80,
              height: 80,
              sx: {
                margin: "15px auto"
              }
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              variant: "rectangular",
              width: "100%",
              height: 30
            })]
          }, i);
        })
      })
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: (data === null || data === void 0 ? void 0 : data.length) > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
      className: (_study_specialization_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section_specialization),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "container",
        children: loading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(LoadingComponent, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: (_study_specialization_module_scss__WEBPACK_IMPORTED_MODULE_9___default().specialization_wrapper),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("ul", {
            children: data === null || data === void 0 ? void 0 : data.map(function (sp, i) {
              var _sp$icon, _sp$icon2;

              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                  legacyBehavior: true,
                  href: "/search?ref=course&sp=".concat(sp === null || sp === void 0 ? void 0 : sp.slug, "&co=").concat(query.country_name, "&limit=10&page=1"),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("li", {
                      className: (_study_specialization_module_scss__WEBPACK_IMPORTED_MODULE_9___default().wrapper),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                        className: (_study_specialization_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon_wrapper),
                        children: (sp === null || sp === void 0 ? void 0 : sp.icon) !== null && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                          className: (_study_specialization_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon_image_wrapper),
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                            src: sp === null || sp === void 0 ? void 0 : (_sp$icon = sp.icon) === null || _sp$icon === void 0 ? void 0 : _sp$icon.src,
                            alt: (sp === null || sp === void 0 ? void 0 : (_sp$icon2 = sp.icon) === null || _sp$icon2 === void 0 ? void 0 : _sp$icon2.alt) || "Alt text"
                          })
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                        title: sp === null || sp === void 0 ? void 0 : sp.specializationName,
                        className: (_study_specialization_module_scss__WEBPACK_IMPORTED_MODULE_9___default().specialization_name),
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                          children: sp === null || sp === void 0 ? void 0 : sp.specializationName
                        })
                      })]
                    })
                  })
                })
              }, sp === null || sp === void 0 ? void 0 : sp.specializationId);
            })
          })
        })
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {})
  });
};
/* harmony default export */ __webpack_exports__["default"] = (StudySpecialization);

/***/ }),

/***/ 5329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StudyOverviewTopRankTwo": function() { return /* binding */ StudyOverviewTopRankTwo; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85014);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91655);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79072);
/* harmony import */ var _modules_study_common_top_rank_uni_card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49922);
/* harmony import */ var _study_top_rank_two_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84908);
/* harmony import */ var _study_top_rank_two_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_study_top_rank_two_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);











var StudyOverviewTopRankTwo = function StudyOverviewTopRankTwo(_ref) {
  var backgroundColor = _ref.backgroundColor,
      padding = _ref.padding,
      heading = _ref.heading,
      subHeading = _ref.subHeading;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      data = _useState[0],
      setData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      error = _useState3[0],
      setError = _useState3[1];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
  var query = router.query;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res, _res$data;

        return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setLoading(true);
                _context.next = 4;
                return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/public/university-ranking/top-ranking?countrySlug=".concat(query === null || query === void 0 ? void 0 : query.country_name, "&limit=8"));

              case 4:
                res = _context.sent;
                setLoading(false);

                if (res.data) {
                  setData(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.dataResult);
                }

                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                setLoading(false);
                setError("Something went wrong");

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
  }, [query === null || query === void 0 ? void 0 : query.country_name]);

  var LoadingComponent = function LoadingComponent() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        variant: "rectangular",
        width: "40%",
        height: 20,
        sx: {
          margin: "20px auto"
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        variant: "rectangular",
        width: "60%",
        height: 40,
        sx: {
          margin: "20px auto"
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
        container: true,
        spacing: 2,
        alignItems: "center",
        children: [1, 2, 3, 4, 5, 6, 7, 8].map(function (_, i) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
            item: true,
            xs: 12,
            sm: 12,
            md: 4,
            lg: 3,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
              variant: "rectangular",
              width: "100%",
              height: 300
            })
          }, i);
        })
      })]
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: (data === null || data === void 0 ? void 0 : data.length) > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
      className: (_study_top_rank_two_module_scss__WEBPACK_IMPORTED_MODULE_9___default().section_top_rank),
      style: {
        backgroundColor: backgroundColor,
        padding: padding
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: (_study_top_rank_two_module_scss__WEBPACK_IMPORTED_MODULE_9___default().wrapper),
        children: loading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(LoadingComponent, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            className: (_study_top_rank_two_module_scss__WEBPACK_IMPORTED_MODULE_9___default().title_wrapper),
            children: [heading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h2", {
              className: (_study_top_rank_two_module_scss__WEBPACK_IMPORTED_MODULE_9___default().title),
              children: heading
            }), subHeading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: subHeading
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "top-rank-slider-wrapper ".concat((_study_top_rank_two_module_scss__WEBPACK_IMPORTED_MODULE_9___default().top_rank_card_wrapper)),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
              container: true,
              spacing: {
                xs: 2,
                sm: 3,
                md: 4
              },
              justifyContent: "center",
              children: data === null || data === void 0 ? void 0 : data.map(function (item, i) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                  item: true,
                  lg: 3,
                  md: 4,
                  sm: 6,
                  xs: 12,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_modules_study_common_top_rank_uni_card__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    data: item
                  }, i)
                }, i);
              })
            })
          })]
        })
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {})
  });
};
/* harmony default export */ __webpack_exports__["default"] = (StudyOverviewTopRankTwo);

/***/ }),

/***/ 40768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StudyVideo": function() { return /* binding */ StudyVideo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_study_common_play_btn_with_ripple__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42422);
/* harmony import */ var _study_video_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25850);
/* harmony import */ var _study_video_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_study_video_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72145);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


var ModalVideo = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 6635).then(__webpack_require__.bind(__webpack_require__, 61239));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61239)];
    }
  }
});






var StudyVideo = function StudyVideo(props) {
  var _pageData$featureImag, _pageData$featureImag2;

  var pageData = props.pageData;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      videoSrc = _useState2[0],
      setVideoSrc = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      videoType = _useState3[0],
      setVideoType = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      embededCode = _useState4[0],
      setEmbededCode = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if ((pageData === null || pageData === void 0 ? void 0 : pageData.videoType) === "upload") {
      var _pageData$videoupload;

      setVideoSrc(pageData === null || pageData === void 0 ? void 0 : (_pageData$videoupload = pageData.videoupload) === null || _pageData$videoupload === void 0 ? void 0 : _pageData$videoupload.src);
      setVideoType("custom");
      setEmbededCode("");
    } else {
      setVideoSrc("");
      setVideoType("youtube");
      setEmbededCode(pageData === null || pageData === void 0 ? void 0 : pageData.embedCode);
    }
  }, [pageData === null || pageData === void 0 ? void 0 : pageData.videoType]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
    className: (_study_video_module_scss__WEBPACK_IMPORTED_MODULE_6___default().section_study_video),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: (_study_video_module_scss__WEBPACK_IMPORTED_MODULE_6___default().study_video_wrapper),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
          className: (_study_video_module_scss__WEBPACK_IMPORTED_MODULE_6___default().video_area),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default()), {
            layout: "responsive",
            width: 850,
            height: 450,
            blurDataURL: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
            placeholder: "blur",
            className: (_study_video_module_scss__WEBPACK_IMPORTED_MODULE_6___default().featured_image),
            src: (pageData === null || pageData === void 0 ? void 0 : (_pageData$featureImag = pageData.featureImage) === null || _pageData$featureImag === void 0 ? void 0 : _pageData$featureImag.src) || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
            alt: (pageData === null || pageData === void 0 ? void 0 : (_pageData$featureImag2 = pageData.featureImage) === null || _pageData$featureImag2 === void 0 ? void 0 : _pageData$featureImag2.alt) || "Feature Image"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_modules_study_common_play_btn_with_ripple__WEBPACK_IMPORTED_MODULE_2__/* .PlayButtonWithRipple */ .s, {
            onClick: function onClick() {
              return setOpen(true);
            }
          }), videoType === "custom" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(ModalVideo, {
            channel: videoType,
            autoplay: true,
            isOpen: isOpen // videoId={`${pageData?.embedCode}`}
            ,
            url: videoSrc // url={}
            ,
            onClose: function onClose() {
              return setOpen(false);
            }
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(ModalVideo, {
            channel: videoType,
            autoplay: true,
            isOpen: isOpen // videoId={`${pageData?.embedCode}`}
            ,
            videoId: embededCode // url={}
            ,
            onClose: function onClose() {
              return setOpen(false);
            }
          })]
        })
      })
    })
  });
};
/* harmony default export */ __webpack_exports__["default"] = (StudyVideo);

/***/ }),

/***/ 32182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72145);
/* harmony import */ var _unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90705);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89583);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5434);
/* harmony import */ var _uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47384);
/* harmony import */ var _uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);









var UniThumbGridBox = function UniThumbGridBox(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().box),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
      legacyBehavior: true,
      href: props.universityLink,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().image_wrapper),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            src: props.featuredImage || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/uni-profile/harvard-university.jpg"),
            alt: props.featuredImageAlt || "University banner",
            className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().banner)
          }), props.logo && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().logo_wrapper),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
              src: props.logo,
              alt: props.logoAlt || "University logo",
              className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().logo)
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().profile_box_content),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().infos),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
          legacyBehavior: true,
          href: props.universityLink,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().name),
              children: props.name || "University Name"
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().info),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdLocationOn */ .$0r, {})
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
            children: [props.address && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
              children: [props.address, ", "]
            }), props.city && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
              children: [props.city, ", "]
            }), props.state && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
              children: [props.state, ", "]
            }), props.country && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
              children: props.country
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().info),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_6__/* .FaUniversity */ .Q7H, {
              style: {
                marginTop: "-4px"
              }
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
            children: [props.universityType && (0,_unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .upperFirstLetter */ .cK)(props.universityType), " ", "University, ", props.estd && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
              children: ["Estd ", props.estd]
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("button", {
          className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().follow),
          children: "+ Follow"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().links),
        children: props.courseNumber !== 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
          legacyBehavior: true,
          href: props.courseLink,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
            className: (_uni_thumb_grid_box_module_scss__WEBPACK_IMPORTED_MODULE_4___default().all_courses),
            children: ["View all ", props.courseNumber, " Courses \u203A"]
          })
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (UniThumbGridBox);

/***/ }),

/***/ 72275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86893);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var Advertisement = function Advertisement(_ref) {
  var _ref$url = _ref.url,
      url = _ref$url === void 0 ? "#" : _ref$url,
      _ref$src = _ref.src,
      src = _ref$src === void 0 ? "/temp/add-row.png" : _ref$src,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "900" : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "110" : _ref$height,
      className = _ref.className,
      style = _ref.style,
      _ref$isPlaceholder = _ref.isPlaceholder,
      isPlaceholder = _ref$isPlaceholder === void 0 ? false : _ref$isPlaceholder;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      show = _useState[0],
      setShow = _useState[1];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: show && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      style: {
        style: style
      },
      className: "flex justify-center ".concat(className ? className : ""),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "relative",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
          onClick: function onClick() {
            return setShow(false);
          },
          className: "absolute right-[1px] top-[1px] bg-white z-10 hover:text-red-600 transition-all",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_3__/* .FiX */ .q5L, {})
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
          href: url,
          rel: "nofollow",
          target: "_blank",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
            alt: "Advertisement",
            src: src,
            width: width,
            height: height,
            style: {
              height: height
            }
          })
        }), isPlaceholder && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: "absolute text-white text-[50px] font-semibold z-10 w-full text-center",
          style: {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
          },
          children: [width, " x ", height]
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Advertisement);

/***/ }),

/***/ 75693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72275);
/* harmony import */ var _hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14418);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var AdvertisementRow = function AdvertisementRow(_ref) {
  var _ref$srcDesktop = _ref.srcDesktop,
      srcDesktop = _ref$srcDesktop === void 0 ? "/temp/add-row.png" : _ref$srcDesktop,
      _ref$srcMobile = _ref.srcMobile,
      srcMobile = _ref$srcMobile === void 0 ? "/temp/add-column-sm.png" : _ref$srcMobile,
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? "#" : _ref$url;

  var _useWindowDimensions = (0,_hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(),
      width = _useWindowDimensions.width;

  if (width > 900) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(___WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      url: url,
      width: 920,
      height: 90,
      src: srcDesktop
    });
  } else {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(___WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      url: url,
      width: 336,
      height: 280,
      src: srcMobile
    });
  }
};

/* harmony default export */ __webpack_exports__["Z"] = (AdvertisementRow);

/***/ }),

/***/ 56753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14418);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var GoogleAdTop = function GoogleAdTop(_ref) {
  var className = _ref.className;

  var _useWindowDimensions = (0,_hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(),
      width = _useWindowDimensions.width;

  var showGoogleAdScriptTop = function showGoogleAdScriptTop() {
    if (width > 0 && width < 640) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          async: true,
          src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972",
          crossorigin: "anonymous"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ins", {
          className: "adsbygoogle",
          style: {
            display: "inline-block",
            width: "450px",
            height: "250px"
          },
          "data-ad-client": "ca-pub-1690314786863972",
          "data-ad-slot": "8403655196"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          children: "(adsbygoogle = window.adsbygoogle || []).push({});"
        })]
      });
    } else if (width > 640 && width < 1024) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          async: true,
          src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972",
          crossorigin: "anonymous"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ins", {
          className: "adsbygoogle",
          style: {
            display: "inline-block",
            width: "720px",
            height: "90px"
          },
          "data-ad-client": "ca-pub-1690314786863972",
          "data-ad-slot": "2900310407"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          children: "(adsbygoogle = window.adsbygoogle || []).push({});"
        })]
      });
    } else if (width > 1024) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          async: true,
          src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972",
          crossorigin: "anonymous"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ins", {
          className: "adsbygoogle",
          style: {
            display: "inline-block",
            width: "1000px",
            height: "250px"
          },
          "data-ad-client": "ca-pub-1690314786863972",
          "data-ad-slot": "9661445287"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          children: "(adsbygoogle = window.adsbygoogle || []).push({});"
        })]
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "flex justify-center mx-auto mb-5 ".concat(className ? className : ""),
    children: showGoogleAdScriptTop()
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GoogleAdTop);

/***/ }),

/***/ 74155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E6": function() { return /* reexport */ DownloadGuide; },
  "qq": function() { return /* reexport */ MessageComponent; },
  "Dk": function() { return /* reexport */ PersonList; },
  "sk": function() { return /* reexport */ common_form/* UniEditorSmall */.sk; },
  "z9": function() { return /* reexport */ useIsMount; }
});

// UNUSED EXPORTS: DatePickerComponent, DateRangeComponent, Dropdown, Editor, ImageInput, MultipleFileInput, PersonProfile, TimePeriod, Title, UniEditor, UniEditorDefault, UniEditorMedium, UniSugessions

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/title.jsx




var Title = function Title(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.heading,
    children: [title && /*#__PURE__*/_jsx("h3", {
      children: title
    }), subtitle && /*#__PURE__*/_jsx("p", {
      children: subtitle
    })]
  });
};
/* harmony default export */ var title = ((/* unused pure expression or super */ null && (Title)));
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/dropdown.jsx


var _excluded = (/* unused pure expression or super */ null && (["topLabel", "bottomLabel", "options", "placeholder", "className", "selectedValue", "inputId", "onChange", "register"]));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Dropdown = function Dropdown(_ref) {
  var topLabel = _ref.topLabel,
      bottomLabel = _ref.bottomLabel,
      options = _ref.options,
      placeholder = _ref.placeholder,
      className = _ref.className,
      selectedValue = _ref.selectedValue,
      inputId = _ref.inputId,
      _onChange = _ref.onChange,
      register = _ref.register,
      rest = _objectWithoutProperties(_ref, _excluded);

  // const [value, setValue] = useState("");
  // useEffect(() => {
  //   setValue(selectedValue);
  // }, [selectedValue]);
  // const handleChange = (e) => {
  //   const { label, value } = e;
  //   setValue(value);
  //   if (onChange) {
  //     onChange(e);
  //   }
  // };
  var customStyles = {
    control: function control(base, state) {
      return _objectSpread(_objectSpread({}, base), {}, _defineProperty({
        height: "50px",
        boxShadow: " 0px 2px 5px rgba(38, 51, 77, 0.03)",
        borderColor: "none",
        "&:hover": {
          borderColor: "none"
        }
      }, "borderColor", state.isFocused ? "#e0e0e0" : "#e0e0e0"));
    },
    option: function option(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        cursor: "pointer",
        color: state.isSelected ? "#F47F20" : "#B5B5C3",
        backgroundColor: state.isSelected ? "#F5F6FC" : state.isFocused ? "#fff" : provided.backgroundColor,
        "&:hover": {
          backgroundColor: "#F5F6FC",
          color: "#F47F20"
        }
      });
    },
    menuPortal: function menuPortal(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        zIndex: 9999
      });
    }
  };
  return /*#__PURE__*/_jsxs(FormControl, {
    fullWidth: true,
    children: [topLabel && /*#__PURE__*/_jsx("label", {
      className: topLabel === "transparent" && styles.transparent,
      children: topLabel
    }), /*#__PURE__*/_jsx(Select, _defineProperty({
      className: "".concat(styles.select_input, " ").concat(className),
      options: options,
      onChange: _onChange,
      placeholder: placeholder && placeholder,
      styles: customStyles
    }, "onChange", function onChange(val) {
      return _onChange(val.value);
    })), bottomLabel && /*#__PURE__*/_jsx("label", {
      children: bottomLabel
    })]
  });
};
/* harmony default export */ var dropdown = ((/* unused pure expression or super */ null && (Dropdown)));
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/useIsMount.jsx

var useIsMount = function useIsMount() {
  var isMountRef = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    isMountRef.current = false;
  }, []);
  return isMountRef.current;
};
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/index.js



// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton_IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(1890);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(77745);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(95398);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardHeader/CardHeader.js + 1 modules
var CardHeader = __webpack_require__(59742);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(76779);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment_moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment_moment);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-icons/cg/index.esm.js
var cg_index_esm = __webpack_require__(80471);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./node_modules/react-timeago/es6/index.js
var es6 = __webpack_require__(92042);
// EXTERNAL MODULE: ./_unisearch/common/chatbox/person_list/list.module.scss
var list_module = __webpack_require__(6867);
var list_module_default = /*#__PURE__*/__webpack_require__.n(list_module);
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/person_list/index.jsx



/* eslint-disable @next/next/no-img-element */

















var PersonList = function PersonList(_ref) {
  var _connectedUserList$so;

  var data = _ref.data,
      clickHandler = _ref.clickHandler,
      chatId = _ref.chatId,
      setCurrentChat = _ref.setCurrentChat,
      socket = _ref.socket,
      connectedUserList = _ref.connectedUserList,
      getConnectedUserList = _ref.getConnectedUserList,
      loading = _ref.loading,
      setLoading = _ref.setLoading,
      customClasses = _ref.customClasses,
      closeDrawer = _ref.closeDrawer;

  var _useState = (0,react.useState)(),
      activeProfile = _useState[0],
      setActiveProfile = _useState[1];

  var _useState2 = (0,react.useState)(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      userList = _useState3[0],
      setUserList = _useState3[1];

  var router = (0,next_router.useRouter)(); // open chat box

  var handleClick = function handleClick(person) {
    if (clickHandler) clickHandler(person);
  };

  var handleOpen = function handleOpen() {
    setOpen(true);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  }; // get university list to add into friend list


  var getUserList = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(keyword) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (keyword && keyword.length >= 2 && keyword != "") {
                setLoading(true);
                setTimeout( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                  return regenerator_default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return api/* default.get */.Z.get("/chat-service/get-users/".concat(keyword)).then(function (res) {
                            if (!res.error) {
                              setUserList(res.data);
                              setLoading(false);
                            }
                          });

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })), 2000);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getUserList(_x) {
      return _ref2.apply(this, arguments);
    };
  }(); // add user into chat list


  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(payload) {
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return api/* default.post */.Z.post("/chat-service/add-user", {
                recieverId: parseInt((payload === null || payload === void 0 ? void 0 : payload.userTypeSlug) === "mentor" ? payload === null || payload === void 0 ? void 0 : payload.id : payload === null || payload === void 0 ? void 0 : payload.universityId),
                recieverType: payload === null || payload === void 0 ? void 0 : payload.userTypeSlug,
                senderTime: new Date()
              }).then( /*#__PURE__*/function () {
                var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(res) {
                  var _res$data;

                  return regenerator_default().wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (res.error) {
                            _context3.next = 7;
                            break;
                          }

                          handleClose();
                          _context3.next = 4;
                          return getConnectedUserList();

                        case 4:
                          setUserList([]);
                          setActiveProfile();
                          router.push("/app/student/messages?chatId=".concat((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.uid));

                        case 7:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x3) {
                  return _ref5.apply(this, arguments);
                };
              }());

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleSubmit(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((list_module_default()).list_wrapper, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (list_module_default()).header_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          className: "btn btn-sm btn-outline-grey ".concat((list_module_default()).btn_add_user),
          onClick: handleOpen,
          children: "New User"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Close/* default */.Z, {
          className: (list_module_default()).btn_close,
          onClick: closeDrawer
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(IconButton_IconButton/* default */.Z, {
          onClick: handleOpen,
          className: "".concat((list_module_default()).btn_plus, " relative"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "uni-tooltip",
            children: "New User"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (list_module_default()).chatt_box_wrapper,
        children: connectedUserList && (connectedUserList === null || connectedUserList === void 0 ? void 0 : connectedUserList.length) > 0 && (connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$so = connectedUserList.sort(function (a, b) {
          var _b$recentMsg, _b$recentMsg$chat_ser, _a$recentMsg;

          return b === null || b === void 0 ? void 0 : (_b$recentMsg = b.recentMsg) === null || _b$recentMsg === void 0 ? void 0 : (_b$recentMsg$chat_ser = _b$recentMsg.chat_service_message_senderTime) === null || _b$recentMsg$chat_ser === void 0 ? void 0 : _b$recentMsg$chat_ser.localeCompare(a === null || a === void 0 ? void 0 : (_a$recentMsg = a.recentMsg) === null || _a$recentMsg === void 0 ? void 0 : _a$recentMsg.chat_service_message_senderTime);
        })) === null || _connectedUserList$so === void 0 ? void 0 : _connectedUserList$so.map(function (item, index) {
          var _item$receiver, _item$receiver$name, _item$receiver2, _item$receiver3, _item$receiver4, _item$receiver5, _item$receiver6, _item$recentMsg, _item$recentMsg2, _item$recentMsg3;

          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              handleClick(item);
              setCurrentChat(item === null || item === void 0 ? void 0 : item.receiver);
              setActiveProfile(item);

              if (closeDrawer) {
                closeDrawer();
              }
            },
            className: item && (item === null || item === void 0 ? void 0 : item.uid) == chatId ? (list_module_default()).active_chatt_box : (list_module_default()).chatt_box,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (list_module_default()).chatt,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (list_module_default()).image_wrapper,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  style: (item === null || item === void 0 ? void 0 : (_item$receiver = item.receiver) === null || _item$receiver === void 0 ? void 0 : _item$receiver.userTypeSlug) === "university" ? {
                    objectFit: "contain"
                  } : {},
                  alt: (_item$receiver$name = item === null || item === void 0 ? void 0 : (_item$receiver2 = item.receiver) === null || _item$receiver2 === void 0 ? void 0 : _item$receiver2.name) !== null && _item$receiver$name !== void 0 ? _item$receiver$name : "",
                  src: item !== null && item !== void 0 && (_item$receiver3 = item.receiver) !== null && _item$receiver3 !== void 0 && _item$receiver3.media ? (item === null || item === void 0 ? void 0 : (_item$receiver4 = item.receiver) === null || _item$receiver4 === void 0 ? void 0 : _item$receiver4.media) === null ? (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png") : item === null || item === void 0 ? void 0 : (_item$receiver5 = item.receiver) === null || _item$receiver5 === void 0 ? void 0 : _item$receiver5.media : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png")
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (list_module_default()).chatt_msg,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                    children: item === null || item === void 0 ? void 0 : (_item$receiver6 = item.receiver) === null || _item$receiver6 === void 0 ? void 0 : _item$receiver6.name
                  }), item !== null && item !== void 0 && item.recentMsg ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: item === null || item === void 0 ? void 0 : (_item$recentMsg = item.recentMsg) === null || _item$recentMsg === void 0 ? void 0 : _item$recentMsg.chat_service_message_messages
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: "You Are Connected"
                  })]
                }), (item === null || item === void 0 ? void 0 : (_item$recentMsg2 = item.recentMsg) === null || _item$recentMsg2 === void 0 ? void 0 : _item$recentMsg2.chat_service_message_createdAt) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (list_module_default()).time,
                  children: moment_default()(item === null || item === void 0 ? void 0 : (_item$recentMsg3 = item.recentMsg) === null || _item$recentMsg3 === void 0 ? void 0 : _item$recentMsg3.chat_service_message_senderTime).fromNow()
                })]
              })]
            })
          }, "plist_".concat(index, "_").concat(item.id));
        }))
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
      open: open,
      onClose: handleClose,
      sx: {
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "600px",
            paddingRight: "2px"
          }
        }
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DialogTitle/* default */.Z, {
        children: ["Start a New Chat", /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
          "aria-label": "close",
          onClick: handleClose,
          sx: {
            position: "absolute",
            right: 8,
            top: 12,
            color: function color(theme) {
              return theme.palette.grey[500];
            }
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(cg_index_esm/* CgClose */.Fk5, {})
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
        dividers: true,
        sx: {
          padding: "0",
          minHeight: "50vh",
          maxHeight: "50vh"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (list_module_default()).search_input_modal,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            autoFocus: true,
            onChange: function onChange(e) {
              getUserList(e.target.value);
            },
            type: "text",
            placeholder: "Search User"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiSearch */.jRj, {
            className: (list_module_default()).search_icon,
            style: {
              fontSize: "20px"
            }
          })]
        }), userList && (userList === null || userList === void 0 ? void 0 : userList.length) > 0 && !loading && (userList === null || userList === void 0 ? void 0 : userList.map(function (item, i) {
          var _item$fullName;

          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              setActiveProfile(item);
            },
            className: activeProfile && activeProfile.email === item.email ? (list_module_default()).active_chatt_box_modal : (list_module_default()).chatt_box,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (list_module_default()).chatt,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (list_module_default()).image_wrapper,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: item.mediaSrc ? item.mediaSrc : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png"),
                  alt: (_item$fullName = item.fullName) !== null && _item$fullName !== void 0 ? _item$fullName : ""
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (list_module_default()).chatt_msg,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [(item === null || item === void 0 ? void 0 : item.fullName) && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                    style: {
                      textTransform: "capitalize"
                    },
                    children: item === null || item === void 0 ? void 0 : item.fullName
                  }), (item === null || item === void 0 ? void 0 : item.email) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                    children: [item === null || item === void 0 ? void 0 : item.email, " (", item === null || item === void 0 ? void 0 : item.userTypeSlug, ")"]
                  })]
                })
              })]
            })
          }, "plist_".concat(i));
        })), loading && Array(6).fill().map(function (item, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
            sx: {
              maxWidth: "100%",
              padding: "0 15px",
              margin: "-16px 0",
              boxShadow: "none"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
              avatar: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
                animation: "wave",
                variant: "circular",
                width: 40,
                height: 40
              }),
              title: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
                animation: "wave",
                height: 10,
                width: "80%",
                style: {
                  marginBottom: 6
                }
              }),
              subheader: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
                animation: "wave",
                height: 10,
                width: "40%"
              })
            })
          }, i);
        }), (userList === null || userList === void 0 ? void 0 : userList.length) === 0 && !loading && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (list_module_default()).no_found,
          children: "No User Found"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
        sx: {
          padding: "12px 20px"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "btn btn-cancel btn-md",
          onClick: handleClose,
          children: "Cancel"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return handleSubmit(activeProfile);
          },
          type: "submit",
          className: "btn btn-secondary btn-md",
          style: {
            minWidth: "82px"
          },
          children: "Add"
        })]
      })]
    })]
  });
};
/* harmony default export */ var person_list = ((/* unused pure expression or super */ null && (PersonList)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-icons/tfi/index.esm.js
var tfi_index_esm = __webpack_require__(81873);
// EXTERNAL MODULE: ./node_modules/react-scroll-to-bottom/lib/esm/index.js + 56 modules
var esm = __webpack_require__(17352);
// EXTERNAL MODULE: ./_unisearch/common/chatbox/message_component/message.module.scss
var message_module = __webpack_require__(42891);
var message_module_default = /*#__PURE__*/__webpack_require__.n(message_module);
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/message_component/index.jsx




/* eslint-disable @next/next/no-img-element */













var MessageComponent = function MessageComponent(_ref) {
  var _messages$, _connectedUserList$fi6, _connectedUserList$fi7, _myMessages$replace;

  var profileInfo = _ref.profileInfo,
      messages = _ref.messages,
      setMessages = _ref.setMessages,
      scrolref = _ref.scrolref,
      _ref$currentChat = _ref.currentChat,
      currentChat = _ref$currentChat === void 0 ? (_messages$ = messages[0]) === null || _messages$ === void 0 ? void 0 : _messages$.receiver : _ref$currentChat,
      getConnectedUserList = _ref.getConnectedUserList,
      _ref$connectedUserLis = _ref.connectedUserList,
      connectedUserList = _ref$connectedUserLis === void 0 ? false : _ref$connectedUserLis,
      chatId = _ref.chatId,
      socket = _ref.socket,
      setArrivalMessage = _ref.setArrivalMessage,
      closeDrawer = _ref.closeDrawer,
      openDrawer = _ref.openDrawer;

  //message state
  var _useState = (0,react.useState)(""),
      myMessages = _useState[0],
      setMyMessages = _useState[1];

  var _useState2 = (0,react.useState)(""),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var addNewLineToTextArea = function addNewLineToTextArea() {
    var msg_text = myMessages + "\r\n";
    setMyMessages(msg_text);
  }; //when press enter send message


  var handleKeyPress = function handleKeyPress(e) {
    var _e$target$value, _e$target$value$repla;

    if (e.keyCode === 13 && e.shiftKey) {
      e.preventDefault();
      addNewLineToTextArea();
    } else if (e.keyCode === 13 && ((_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : (_e$target$value$repla = _e$target$value.replace(/\s/g, "")) === null || _e$target$value$repla === void 0 ? void 0 : _e$target$value$repla.length) >= 1 && !loading) {
      handleSubmitMessage();
    }
  }; // push new message


  var handleSubmitMessage = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var _connectedUserList$fi, _connectedUserList$fi2;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.next = 3;
              return api/* default.post */.Z.post("/chat-service/new-meessage", {
                uid: chatId,
                messages: myMessages,
                recieverId: connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$fi = connectedUserList.find(function (item) {
                  return (item === null || item === void 0 ? void 0 : item.uid) == chatId;
                })) === null || _connectedUserList$fi === void 0 ? void 0 : (_connectedUserList$fi2 = _connectedUserList$fi.receiver) === null || _connectedUserList$fi2 === void 0 ? void 0 : _connectedUserList$fi2.id,
                recieverType: "university",
                senderTime: new Date()
              }).then( /*#__PURE__*/function () {
                var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(res) {
                  var _connectedUserList$fi3, _connectedUserList$fi4, _connectedUserList$fi5;

                  return regenerator_default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!res.error) {
                            setMyMessages("");
                            getConnectedUserList();
                            setMessages(function (prev) {
                              var _res$data, _res$data2, _res$data3, _res$data4, _res$data5, _res$data6, _res$data7, _res$data8, _res$data9, _res$data10, _res$data11, _res$data12;

                              return [].concat((0,toConsumableArray/* default */.Z)(prev), [{
                                id: (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.id,
                                uid: (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.uid,
                                studentId: (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.studentId,
                                senderType: (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.senderType,
                                universityId: (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.universityId,
                                university: (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.university,
                                mentorId: (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.mentorId,
                                mentor: (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.mentor,
                                recieverType: (_res$data9 = res.data) === null || _res$data9 === void 0 ? void 0 : _res$data9.recieverType,
                                messages: (_res$data10 = res.data) === null || _res$data10 === void 0 ? void 0 : _res$data10.messages,
                                createdAt: (_res$data11 = res.data) === null || _res$data11 === void 0 ? void 0 : _res$data11.createdAt,
                                senderTime: res === null || res === void 0 ? void 0 : (_res$data12 = res.data) === null || _res$data12 === void 0 ? void 0 : _res$data12.senderTime
                              }]);
                            });
                            setArrivalMessage(null);
                            socket.current.emit("send-message", {
                              senderId: profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.id,
                              receiverId: connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$fi3 = connectedUserList.find(function (item) {
                                return (item === null || item === void 0 ? void 0 : item.uid) == chatId;
                              })) === null || _connectedUserList$fi3 === void 0 ? void 0 : (_connectedUserList$fi4 = _connectedUserList$fi3.receiver) === null || _connectedUserList$fi4 === void 0 ? void 0 : (_connectedUserList$fi5 = _connectedUserList$fi4.id) === null || _connectedUserList$fi5 === void 0 ? void 0 : _connectedUserList$fi5.toString(),
                              text: myMessages,
                              senderTime: new Date()
                            });
                            setLoading(false);
                          } else {
                            setLoading(false);
                          }

                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmitMessage() {
      return _ref2.apply(this, arguments);
    };
  }(); // rendar message


  var RenderMessage = function RenderMessage(msgData) {
    var _msgData$receiver, _msgData$receiver2, _msgData$receiver3;

    if ((msgData === null || msgData === void 0 ? void 0 : msgData.is_first) == 1) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "chat_time",
        style: {
          fontSize: "13px"
        },
        children: msgData === null || msgData === void 0 ? void 0 : msgData.messages
      });
    } else if (msgData && (msgData === null || msgData === void 0 ? void 0 : msgData.studentId) === (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.id) && (msgData === null || msgData === void 0 ? void 0 : msgData.senderType) === "student") {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (message_module_default()).my_msg_wrapper,
        children: [(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (message_module_default()).my_msg_time,
          children: [moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).fromNow(), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).format("hh:mm A")
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (message_module_default()).my_msg,
          children: [(0,helpers/* newLineText */.$m)(msgData === null || msgData === void 0 ? void 0 : msgData.messages), (msgData === null || msgData === void 0 ? void 0 : msgData.is_read) == 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkDoneOutline */.xOC, {
            className: (message_module_default()).mark
          })]
        })]
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (message_module_default()).buddy_msg_wrapper,
      children: [(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (message_module_default()).msg_time,
        children: [moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).fromNow(), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).format("hh:mm A")
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (message_module_default()).msg_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (message_module_default()).image_wrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            style: (msgData === null || msgData === void 0 ? void 0 : (_msgData$receiver = msgData.receiver) === null || _msgData$receiver === void 0 ? void 0 : _msgData$receiver.userTypeSlug) === "university" ? {
              objectFit: "contain"
            } : {},
            src: msgData !== null && msgData !== void 0 && (_msgData$receiver2 = msgData.receiver) !== null && _msgData$receiver2 !== void 0 && _msgData$receiver2.media ? msgData === null || msgData === void 0 ? void 0 : (_msgData$receiver3 = msgData.receiver) === null || _msgData$receiver3 === void 0 ? void 0 : _msgData$receiver3.media : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png"),
            alt: "avatar"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (message_module_default()).replymsg,
          children: (0,helpers/* newLineText */.$m)(msgData === null || msgData === void 0 ? void 0 : msgData.messages)
        })]
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (message_module_default()).message_component_wrapper,
    children: [currentChat && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (message_module_default()).heading,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(tfi_index_esm/* TfiMenu */.lrj, {
        className: (message_module_default()).heading_menu,
        onClick: openDrawer
      }), connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$fi6 = connectedUserList.find(function (item) {
        return (item === null || item === void 0 ? void 0 : item.uid) == chatId;
      })) === null || _connectedUserList$fi6 === void 0 ? void 0 : (_connectedUserList$fi7 = _connectedUserList$fi6.receiver) === null || _connectedUserList$fi7 === void 0 ? void 0 : _connectedUserList$fi7.name]
    }), messages && currentChat ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.ZP, {
        className: (message_module_default()).conversation_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (message_module_default()).conversation_wrapper_child,
          children: messages && (messages === null || messages === void 0 ? void 0 : messages.length) > 0 && (messages === null || messages === void 0 ? void 0 : messages.map(function (msgData, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "chat_scroll",
              id: "chat_scroll",
              children: RenderMessage(msgData)
            }, (Math.random() + 1).toString(36).substring(7));
          }))
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (message_module_default()).msg_footer_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (message_module_default()).action,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (message_module_default()).left,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (message_module_default()).image_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                alt: "profile",
                src: profileInfo !== null && profileInfo !== void 0 && profileInfo.profileImageSrc ? profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.profileImageSrc : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png")
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", {
              "aria-label": "minimum height",
              style: {
                minHeight: "40px"
              },
              placeholder: "Reply Message...",
              value: myMessages !== null && myMessages !== void 0 ? myMessages : "",
              onChange: function onChange(e) {
                setMyMessages(e.target.value);
              },
              onKeyDown: function onKeyDown(e) {
                if (e.key === "Enter") {
                  e.preventDefault();
                }

                handleKeyPress(e);
              }
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (message_module_default()).action_btn,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
              disabled: (myMessages === null || myMessages === void 0 ? void 0 : (_myMessages$replace = myMessages.replace(/\s/g, "")) === null || _myMessages$replace === void 0 ? void 0 : _myMessages$replace.length) >= 1 ? false : true,
              onClick: handleSubmitMessage,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdSend */.D6S, {})
            })
          })]
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (message_module_default()).details_wrapper2,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (message_module_default()).empty_detail_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Select a chat or start a new conversation"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: openDrawer,
          className: "btn btn-outline-grey btn-sm",
          children: "Start"
        })]
      })
    })]
  });
};
/* harmony default export */ var message_component = ((/* unused pure expression or super */ null && (MessageComponent)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/person_profile/index.jsx




var person_profile_excluded = (/* unused pure expression or super */ null && (["data", "profileType"]));


function person_profile_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function person_profile_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? person_profile_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : person_profile_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable @next/next/no-img-element */














var customStyles = {
  control: function control(base, state) {
    var _objectSpread2;

    return person_profile_objectSpread(person_profile_objectSpread({}, base), {}, (_objectSpread2 = {
      minHeight: "46px",
      boxShadow: state.isFocused ? "none" : "none",
      borderColor: "none",
      "&:hover": {
        borderColor: "none"
      }
    }, (0,defineProperty/* default */.Z)(_objectSpread2, "borderColor", state.isFocused ? "#f5f8fa" : "#f5f8fa"), (0,defineProperty/* default */.Z)(_objectSpread2, "backgroundColor", "#f5f8fa"), (0,defineProperty/* default */.Z)(_objectSpread2, "fontSize", "14px"), _objectSpread2));
  },
  option: function option(provided, state) {
    return person_profile_objectSpread(person_profile_objectSpread({}, provided), {}, {
      cursor: "pointer",
      fontSize: "14px",
      transition: "all 0.3s",
      color: state.isSelected ? "#F47F20" : "#B5B5C3",
      backgroundColor: state.isSelected ? "#F5F6FC" : state.isFocused ? "#fff" : provided.backgroundColor,
      "&:hover": {
        backgroundColor: "#F5F6FC",
        color: "#F47F20"
      }
    });
  },
  menuList: function menuList(base) {
    return person_profile_objectSpread(person_profile_objectSpread({}, base), {}, {
      "::-webkit-scrollbar": {
        width: "5px",
        height: "6px",
        overflow: "visible",
        cursor: "pointer",
        background: "transparent",
        borderRadius: "10px"
      },
      "::-webkit-scrollbar-thumb": {
        background: "rgb(202, 202, 202)",
        borderRadius: "10px",
        cursor: "pointer"
      }
    });
  }
};
var PersonProfile = function PersonProfile(_ref) {
  var _data$name, _profileInfo$workingC, _profileInfo$preferen, _profileInfo$preferen2, _profileInfo$preferen3, _profileInfo$preferen4, _profileInfo$preferen5, _profileInfo$preferen6, _profileInfo$preferen7, _profileInfo$preferen8, _profileInfo$preferen9, _profileInfo$preferen10, _profileInfo$preferen11, _profileInfo$preferen12, _profileInfo$preferen13, _profileInfo$preferen14, _profileInfo$preferen15, _profileInfo$preferen16, _profileInfo$preferen17, _profileInfo$preferen18, _profileInfo$preferen19, _profileInfo$preferen20, _profileInfo$preferen21, _profileInfo$preferen22, _profileInfo$preferen23, _profileInfo$preferen24, _profileInfo$preferen25, _profileInfo$preferen26, _profileInfo$preferen27, _profileInfo$preferen28, _profileInfo$preferen29, _profileInfo$preferen30, _profileInfo$preferen31, _profileInfo$preferen32, _profileInfo$preferen33, _profileInfo$preferen34, _profileInfo$preferen35, _profileInfo$preferen36, _profileInfo$preferen37, _profileInfo$preferen38;

  var data = _ref.data,
      profileType = _ref.profileType,
      props = _objectWithoutProperties(_ref, person_profile_excluded);

  var tZone = getTimeZone();

  var _React$useState = React.useState(new Date()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _useState = useState(moment.tz.guess()),
      currentTzone = _useState[0],
      setCurrentTzone = _useState[1];

  var _useState2 = useState(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(false),
      showInMobile = _useState3[0],
      setShowInMobile = _useState3[1];

  var _useState4 = useState(),
      timeSlot = _useState4[0],
      setTimeslot = _useState4[1];

  var _useState5 = useState({}),
      profileInfo = _useState5[0],
      setProfileInfo = _useState5[1];

  var _useState6 = useState(),
      index = _useState6[0],
      setIndex = _useState6[1];

  var getProfile = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return API.get("/user/any-profile?userType=".concat(profileType, "&id=").concat(data === null || data === void 0 ? void 0 : data.id)).then(function (res) {
                if (!res.error) {
                  setProfileInfo(res.data);
                }
              })["catch"](function (error) {
                swalError("Something went wrong");
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getProfile() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (data !== null && data !== void 0 && data.id && profileType) {
      getProfile();
    }
  }, [data === null || data === void 0 ? void 0 : data.id, profileType]);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var payload;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              payload = {
                date: value,
                counsellorId: data === null || data === void 0 ? void 0 : data.id,
                timezone: currentTzone
              };
              _context2.next = 3;
              return API.post("/student/counsellor-appointment/time-list", payload).then(function (res) {
                if (!res.error) {
                  setTimeslot(res.data);
                }
              })["catch"](function (error) {
                swalError("Something went wrong");
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (data !== null && data !== void 0 && data.id && value && currentTzone && profileType === "counsellor") {
      handleSubmit();
    }
  }, [data === null || data === void 0 ? void 0 : data.id, value, currentTzone, profileType]);

  function formatAMPM(time) {
    // return time;
    var hour = time.split(":");
    var hrs = parseInt(hour[0]);
    var ampm = hrs >= 12 ? "pm" : "am";
    hrs = hrs % 12;
    hrs = hrs ? hrs : 12; // the hour '0' should be '12'

    var strTime = hrs + ":" + hour[1] + " " + ampm;
    return strTime;
  }

  var handleOpen = function handleOpen() {
    setOpen(true);
    document.body.classList.add("popOpen");
    handleSubmit();
  };

  var handleClose = function handleClose() {
    setOpen(false);
    document.body.classList.remove("popOpen");
    setIndex();
  };

  return /*#__PURE__*/_jsxs("div", {
    className: styles.profile_wrapper,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.image_wrapper,
      children: /*#__PURE__*/_jsx("img", {
        src: data.profileImage ? data.profileImage : getAssets("assets/student-avatar-big.png"),
        alt: (_data$name = data === null || data === void 0 ? void 0 : data.name) !== null && _data$name !== void 0 ? _data$name : ""
      })
    }), /*#__PURE__*/_jsx("h2", {
      children: data.name
    }), profileType && profileType == "counsellor" && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.profile_bio,
        children: [profileInfo && (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.bio) && htmlParse(profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.bio), profileInfo && (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.bio) && /*#__PURE__*/_jsx(Link, {
          legacyBehavior: true,
          href: "/app/student/counsellor/".concat(data === null || data === void 0 ? void 0 : data.id),
          children: /*#__PURE__*/_jsx("a", {
            className: styles.read_more,
            children: "Read More"
          })
        })]
      }), (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.workingCountry) && /*#__PURE__*/_jsx("h5", {
        children: "Working Country"
      }), (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.workingCountry) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$workingC = profileInfo.workingCountry) === null || _profileInfo$workingC === void 0 ? void 0 : _profileInfo$workingC.length) > 0 && /*#__PURE__*/_jsx("div", {
        className: styles.country_wrapper,
        children: profileInfo.workingCountry && profileInfo.workingCountry.map(function (item, i) {
          return /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: item
          }, i);
        })
      }), /*#__PURE__*/_jsx("button", {
        onClick: handleOpen,
        className: "btn btn-primary ".concat(styles.book_appiontment),
        children: "Book Appointment"
      })]
    }), profileType && profileType == "student" && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen = profileInfo.preferences) === null || _profileInfo$preferen === void 0 ? void 0 : _profileInfo$preferen.courselevel) && /*#__PURE__*/_jsx("h5", {
          children: "Course Level"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen2 = profileInfo.preferences) === null || _profileInfo$preferen2 === void 0 ? void 0 : (_profileInfo$preferen3 = _profileInfo$preferen2.courselevel) === null || _profileInfo$preferen3 === void 0 ? void 0 : _profileInfo$preferen3.levelName) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen4 = profileInfo.preferences) === null || _profileInfo$preferen4 === void 0 ? void 0 : (_profileInfo$preferen5 = _profileInfo$preferen4.courselevel) === null || _profileInfo$preferen5 === void 0 ? void 0 : _profileInfo$preferen5.levelName
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen6 = profileInfo.preferences) === null || _profileInfo$preferen6 === void 0 ? void 0 : _profileInfo$preferen6.countryPreferences) && /*#__PURE__*/_jsx("h5", {
          children: "Country Preferences"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen7 = profileInfo.preferences) === null || _profileInfo$preferen7 === void 0 ? void 0 : _profileInfo$preferen7.countryPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen8 = profileInfo.preferences) === null || _profileInfo$preferen8 === void 0 ? void 0 : (_profileInfo$preferen9 = _profileInfo$preferen8.countryPreferences) === null || _profileInfo$preferen9 === void 0 ? void 0 : _profileInfo$preferen9.length) > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen10 = profileInfo.preferences) === null || _profileInfo$preferen10 === void 0 ? void 0 : _profileInfo$preferen10.countryPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen11 = profileInfo.preferences) === null || _profileInfo$preferen11 === void 0 ? void 0 : (_profileInfo$preferen12 = _profileInfo$preferen11.countryPreferences) === null || _profileInfo$preferen12 === void 0 ? void 0 : _profileInfo$preferen12.map(function (item, i) {
            return /*#__PURE__*/_jsx("h6", {
              className: styles.country,
              children: item
            }, i);
          }))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen13 = profileInfo.preferences) === null || _profileInfo$preferen13 === void 0 ? void 0 : _profileInfo$preferen13.studyPreferences) && /*#__PURE__*/_jsx("h5", {
          children: "Preferred Courses"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen14 = profileInfo.preferences) === null || _profileInfo$preferen14 === void 0 ? void 0 : _profileInfo$preferen14.studyPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen15 = profileInfo.preferences) === null || _profileInfo$preferen15 === void 0 ? void 0 : (_profileInfo$preferen16 = _profileInfo$preferen15.studyPreferences) === null || _profileInfo$preferen16 === void 0 ? void 0 : _profileInfo$preferen16.length) > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen17 = profileInfo.preferences) === null || _profileInfo$preferen17 === void 0 ? void 0 : _profileInfo$preferen17.studyPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen18 = profileInfo.preferences) === null || _profileInfo$preferen18 === void 0 ? void 0 : (_profileInfo$preferen19 = _profileInfo$preferen18.studyPreferences) === null || _profileInfo$preferen19 === void 0 ? void 0 : _profileInfo$preferen19.map(function (item, i) {
            return /*#__PURE__*/_jsx("h6", {
              className: styles.country,
              children: item
            }, i);
          }))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen20 = profileInfo.preferences) === null || _profileInfo$preferen20 === void 0 ? void 0 : _profileInfo$preferen20.specialization) && /*#__PURE__*/_jsx("h5", {
          children: "Specialization"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen21 = profileInfo.preferences) === null || _profileInfo$preferen21 === void 0 ? void 0 : (_profileInfo$preferen22 = _profileInfo$preferen21.specialization) === null || _profileInfo$preferen22 === void 0 ? void 0 : _profileInfo$preferen22.specializationName) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen23 = profileInfo.preferences) === null || _profileInfo$preferen23 === void 0 ? void 0 : (_profileInfo$preferen24 = _profileInfo$preferen23.specialization) === null || _profileInfo$preferen24 === void 0 ? void 0 : _profileInfo$preferen24.specializationName
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen25 = profileInfo.preferences) === null || _profileInfo$preferen25 === void 0 ? void 0 : _profileInfo$preferen25.intakePreferences) && /*#__PURE__*/_jsx("h5", {
          children: "Intake"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen26 = profileInfo.preferences) === null || _profileInfo$preferen26 === void 0 ? void 0 : _profileInfo$preferen26.intakePreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen27 = profileInfo.preferences) === null || _profileInfo$preferen27 === void 0 ? void 0 : (_profileInfo$preferen28 = _profileInfo$preferen27.intakePreferences) === null || _profileInfo$preferen28 === void 0 ? void 0 : _profileInfo$preferen28.length) > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen29 = profileInfo.preferences) === null || _profileInfo$preferen29 === void 0 ? void 0 : _profileInfo$preferen29.intakePreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen30 = profileInfo.preferences) === null || _profileInfo$preferen30 === void 0 ? void 0 : (_profileInfo$preferen31 = _profileInfo$preferen30.intakePreferences) === null || _profileInfo$preferen31 === void 0 ? void 0 : _profileInfo$preferen31.map(function (item, i) {
            var year = item.year,
                data = item.data;
            var last = Object.keys(data).length - 1;
            var payload = {
              year: year,
              from: data[Object.keys(data)[0]],
              to: data[Object.keys(data)[last]]
            };
            return /*#__PURE__*/_jsx("h6", {
              className: styles.country,
              children: "".concat(payload.from, "-").concat(payload.to, ", ").concat(payload.year)
            }, i);
          }))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen32 = profileInfo.preferences) === null || _profileInfo$preferen32 === void 0 ? void 0 : _profileInfo$preferen32.budget) && /*#__PURE__*/_jsx("h5", {
          children: "Budget"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen33 = profileInfo.preferences) === null || _profileInfo$preferen33 === void 0 ? void 0 : _profileInfo$preferen33.budget) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen34 = profileInfo.preferences) === null || _profileInfo$preferen34 === void 0 ? void 0 : _profileInfo$preferen34.budget
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen35 = profileInfo.preferences) === null || _profileInfo$preferen35 === void 0 ? void 0 : _profileInfo$preferen35.objective) && /*#__PURE__*/_jsx("h5", {
          children: "Objective"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen36 = profileInfo.preferences) === null || _profileInfo$preferen36 === void 0 ? void 0 : _profileInfo$preferen36.objective) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen37 = profileInfo.preferences) === null || _profileInfo$preferen37 === void 0 ? void 0 : (_profileInfo$preferen38 = _profileInfo$preferen37.objective) === null || _profileInfo$preferen38 === void 0 ? void 0 : _profileInfo$preferen38.objectivePurpose
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Modal, {
      open: open,
      onClose: handleClose,
      closeAfterTransition: true,
      BackdropComponent: Backdrop,
      BackdropProps: {
        timeout: 500
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "modal ".concat(styles.modal_custom_width),
        children: [/*#__PURE__*/_jsx("button", {
          className: "".concat(styles.cross_icon, " cross_icon"),
          onClick: handleClose,
          children: /*#__PURE__*/_jsx(FiX, {})
        }), /*#__PURE__*/_jsx("div", {
          className: styles.appoint_modal,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.appoint_modal_right,
            children: [/*#__PURE__*/_jsx("h3", {
              className: styles.appoint_title,
              children: "Select a Date & Time"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.appoint_calender_and_time_wrapper,
              children: [/*#__PURE__*/_jsxs("div", {
                className: "".concat(styles.calender_and_time_zone_wrapper, " ").concat(showInMobile ? styles.active : ""),
                children: [/*#__PURE__*/_jsx("div", {
                  style: {
                    maxHeight: "310px"
                  },
                  children: /*#__PURE__*/_jsx(LocalizationProvider, {
                    dateAdapter: AdapterDateFns,
                    children: /*#__PURE__*/_jsx(StaticDatePicker, {
                      className: "appointModalDatePicker",
                      displayStaticWrapperAs: "desktop",
                      openTo: "day",
                      minDate: new Date(),
                      value: value,
                      onChange: function onChange(newValue) {
                        setValue(newValue);
                        setShowInMobile(true);
                        setIndex();
                      },
                      renderInput: function renderInput(params) {
                        return /*#__PURE__*/_jsx(TextField, person_profile_objectSpread({}, params));
                      }
                    })
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.time_zone_wrapper,
                  children: [/*#__PURE__*/_jsx("label", {
                    className: styles.label,
                    children: "Select Time Zone"
                  }), /*#__PURE__*/_jsx(Select, {
                    menuPlacement: "top",
                    placeholder: "Select Timezone",
                    styles: customStyles,
                    options: tZone,
                    value: currentTzone && tZone ? tZone.filter(function (tz) {
                      return tz.value == currentTzone;
                    }) : "",
                    onChange: function onChange(item) {
                      setCurrentTzone(item.value);
                      setIndex();
                    }
                  })]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "".concat(styles.appoint_time_wrapper, " ").concat(showInMobile ? styles.active : ""),
                children: [/*#__PURE__*/_jsxs("div", {
                  className: styles.back_icon_and_date_wrapper,
                  children: [/*#__PURE__*/_jsx(IconButton, {
                    onClick: function onClick() {
                      return setShowInMobile(false);
                    },
                    className: styles.back_btn,
                    children: /*#__PURE__*/_jsx(ArrowBackIcon, {})
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.appoint_time_title,
                    children: new Date(value).toDateString()
                  })]
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.appoint_time_list_wrapper,
                  children: /*#__PURE__*/_jsx("ul", {
                    children: timeSlot && timeSlot.length > 0 ? timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.map(function (item, i) {
                      return /*#__PURE__*/_jsxs("li", {
                        children: [/*#__PURE__*/_jsxs("button", {
                          onClick: function onClick() {
                            return setIndex(i);
                          },
                          className: "".concat(styles.appoint_time_btn, " ").concat(index === i ? styles.active : ""),
                          children: [formatAMPM(item === null || item === void 0 ? void 0 : item.startTime), "-", formatAMPM(item === null || item === void 0 ? void 0 : item.endTime)]
                        }), /*#__PURE__*/_jsx("button", {
                          className: "".concat(styles.confirm_btn, " ").concat(index === i ? styles.active : "", " btn btn-secondary btn-bg"),
                          onClick: function onClick() {
                            handleFormSubmit(item === null || item === void 0 ? void 0 : item.timeId);
                          },
                          children: "Confirm"
                        })]
                      }, i);
                    }) : /*#__PURE__*/_jsx("li", {
                      className: styles.no_record,
                      children: "\"No Appoinment Schedule\""
                    })
                  })
                })]
              })]
            })]
          })
        })]
      })
    })]
  });
};
/* harmony default export */ var person_profile = ((/* unused pure expression or super */ null && (PersonProfile)));
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/index.js



// EXTERNAL MODULE: ./_unisearch/common/form/index.js + 15 modules
var common_form = __webpack_require__(15603);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./_recoil/_actions/index.js + 5 modules
var _actions = __webpack_require__(8612);
// EXTERNAL MODULE: ./_recoil/_state/index.js + 9 modules
var _state = __webpack_require__(89093);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(93162);
;// CONCATENATED MODULE: ./_unisearch/common/download_guide/index.jsx


var download_guide_excluded = ["fileSrc", "btnTitle", "fileName", "documentType", "customClasses", "customStyles", "universityId", "documentId"];











/*
documentType -> 'prospectus', 'exam', 'document', 'course', 'ebook', 'countryguide'

This componetn takes props
-> fileSrc
-> fileName
-> btnTitle
-> documentType
-> universityId
-> documentId
-> customClasses={
        root.[your class name]
    }
-> customClasses={
        title.[your class name]
   }
-> customClasses={
        tooltip.[your class name]
    }
-> customStyles={{ root: { color: "blue" } }}
-> customStyles={{ title: { fontSize: "30px" } }}
-> customStyles={{ tooltip: { color: "blue" } }}
 */



var DownloadGuide = function DownloadGuide(_ref) {
  var fileSrc = _ref.fileSrc,
      btnTitle = _ref.btnTitle,
      fileName = _ref.fileName,
      _ref$documentType = _ref.documentType,
      documentType = _ref$documentType === void 0 ? "prospectus" : _ref$documentType,
      customClasses = _ref.customClasses,
      customStyles = _ref.customStyles,
      _ref$universityId = _ref.universityId,
      universityId = _ref$universityId === void 0 ? 0 : _ref$universityId,
      _ref$documentId = _ref.documentId,
      documentId = _ref$documentId === void 0 ? 0 : _ref$documentId,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, download_guide_excluded);

  var router = (0,next_router.useRouter)();
  var systemActions = (0,_actions/* useSystemActions */.x3)();
  var profileInfos = (0,recoil/* useRecoilValue */.sJ)(_state/* authAtom */.L4);

  var _useState = (0,react.useState)(),
      profileInfo = _useState[0],
      setProfileInfo = _useState[1];

  (0,react.useEffect)(function () {
    setProfileInfo(profileInfos);
  }, []);

  var storeStudentDownloadInfo = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return api/* default.post */.Z.post("/student/download-activity", {
                universityId: universityId,
                type: documentType,
                mediaId: documentId
              }).then(function (res) {});

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              (0,helpers/* swalError */.Kj)("Something went wrong");

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function storeStudentDownloadInfo() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleDownload = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(fileSrc) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (profileInfo) {
                _context2.next = 3;
                break;
              }

              systemActions.setReturnUrl(router.asPath);
              return _context2.abrupt("return", router.push({
                pathname: "/signin"
              }));

            case 3:
              if (profileInfo && profileInfo.userTypeSlug === "student") {
                storeStudentDownloadInfo();
              }

              window.open(fileSrc, "_blank");

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleDownload(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
    onClick: function onClick() {
      handleDownload(fileSrc);
    },
    className: "btn btn-secondary relative ".concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
    style: customStyles === null || customStyles === void 0 ? void 0 : customStyles.root,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdPictureAsPdf */.OY_, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "".concat(customClasses !== null && customClasses !== void 0 && customClasses.title ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.title : ""),
      style: customStyles === null || customStyles === void 0 ? void 0 : customStyles.title,
      children: btnTitle || "Download Brochure"
    }), !profileInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: "uni-tooltip ".concat(customClasses !== null && customClasses !== void 0 && customClasses.tooltip ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.tooltip : ""),
      style: customStyles === null || customStyles === void 0 ? void 0 : customStyles.tooltip,
      children: ["Please Login ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " to perform this action"]
    })]
  });
};
/* harmony default export */ var download_guide = ((/* unused pure expression or super */ null && (DownloadGuide)));
;// CONCATENATED MODULE: ./_unisearch/common/index.js





/***/ }),

/***/ 1692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BookmarkAction": function() { return /* binding */ BookmarkAction; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72145);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85014);
/* harmony import */ var _recoil_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8612);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89093);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89583);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2804);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53913);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_actions_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_icons_im__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(53990);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);















var BookmarkAction = function BookmarkAction(_ref) {
  var customClasses = _ref.customClasses,
      referance = _ref.referance,
      referanceId = _ref.referanceId,
      is_bookmarked = _ref.is_bookmarked,
      _ref$showText = _ref.showText,
      showText = _ref$showText === void 0 ? true : _ref$showText,
      _ref$getReadingList = _ref.getReadingList,
      getReadingList = _ref$getReadingList === void 0 ? false : _ref$getReadingList;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      profileInfo = _useState[0],
      setProfileInfo = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
  var systemActions = (0,_recoil_actions__WEBPACK_IMPORTED_MODULE_4__/* .useSystemActions */ .x3)();
  var authActions = (0,_recoil_actions__WEBPACK_IMPORTED_MODULE_4__/* .useAuthActions */ .X$)();
  var profileInfos = (0,recoil__WEBPACK_IMPORTED_MODULE_7__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_5__/* .authAtom */ .L4); //referanceItems =  (blog,page )

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    //remove redirect url
    systemActions.removeReturnUrl();
  }, [systemActions]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (profileInfos) {
      setProfileInfo(profileInfos);
    }
  }, []); //Handle Bookmarke

  var handleBookmark = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
      var payload;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(profileInfo && profileInfo.userTypeSlug === "student")) {
                _context2.next = 7;
                break;
              }

              setIsLoading(true);
              payload = {
                readingType: referance,
                referenceId: referanceId
              };
              _context2.next = 5;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/student/reading-list", payload).then( /*#__PURE__*/function () {
                var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(resp) {
                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(!resp.error && resp.data)) {
                            _context.next = 7;
                            break;
                          }

                          _context.next = 3;
                          return authActions.getProfile();

                        case 3:
                          setIsLoading(false);
                          if (getReadingList) getReadingList();
                          _context.next = 9;
                          break;

                        case 7:
                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__/* .swalError */ .Kj)(resp.error);
                          setIsLoading(false);

                        case 9:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 5:
              _context2.next = 10;
              break;

            case 7:
              systemActions.setReturnUrl(router.asPath);
              _context2.next = 10;
              return router.push({
                pathname: "/signin"
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleBookmark() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
    children: is_bookmarked ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
      className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bookmarke_wrapper), " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("button", {
        className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btn_bookmark), " ").concat(is_bookmarked ? (_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().active) : "", " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.btnClass ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.btnClass : ""),
        onClick: function onClick() {
          return handleBookmark();
        },
        children: [!isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaBookmark */ .VF9, {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().reg_bookmark)),
          style: {
            color: "#f47f20"
          }
        }), referanceId && isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_im__WEBPACK_IMPORTED_MODULE_12__/* .ImSpinner8 */ .IDg, {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon_spin))
        }), showText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          children: "Bookmarked"
        })]
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: "relative ".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bookmarke_wrapper), " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("button", {
        className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btn_bookmark), " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.btnClass ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.btnClass : ""),
        onClick: function onClick() {
          return handleBookmark();
        },
        children: [!isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaRegBookmark */ .mCg, {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().reg_bookmark))
        }), referanceId && isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_im__WEBPACK_IMPORTED_MODULE_12__/* .ImSpinner8 */ .IDg, {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon_spin))
        }), showText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          children: "Add to Bookmark"
        })]
      }), (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isEmpty */ .xb)(profileInfo) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        className: "uni-tooltip",
        children: ["Please Login ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), " to perform this action"]
      })]
    })
  });
};
/* harmony default export */ __webpack_exports__["default"] = (BookmarkAction);

/***/ }),

/***/ 90312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ChatAction */
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85014);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5434);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53913);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_actions_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["recieverType", "uniId"];







var ChatAction = function ChatAction(_ref) {
  var recieverType = _ref.recieverType,
      uniId = _ref.uniId,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var connectChat = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(uniId) {
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/chat-service/add-user", {
                recieverId: parseInt(uniId),
                recieverType: recieverType !== null && recieverType !== void 0 ? recieverType : "university",
                senderTime: new Date()
              }).then( /*#__PURE__*/function () {
                var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(res) {
                  var _res$data;

                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!res.error) {
                            router.push("/app/student/messages?chatId=".concat((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.uid));
                          }

                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function connectChat(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var renderComponent = function renderComponent() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_6___default().connect_wrapper), "  relative"),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_7__/* .MdOutlineQuestionAnswer */ .Iqb, {
        onClick: function onClick() {
          connectChat(uniId);
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "uni-tooltip",
        children: "Chat"
      })]
    });
  };

  if (true) {
    return renderComponent();
  } else {}
};
/* harmony default export */ __webpack_exports__["Z"] = (ChatAction);

/***/ }),

/***/ 10534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConversationAction */
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4730);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15825);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(58735);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70754);
/* harmony import */ var _unisearch_common_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15603);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85014);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82580);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(86893);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(51649);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74231);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(25934);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(53913);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_actions_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72145);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);


var _excluded = ["email"];















var ConversationAction = function ConversationAction(_ref) {
  var email = _ref.email,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref, _excluded);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false),
      conLoading = _useState[0],
      setConLoading = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false),
      conversationModal = _useState2[0],
      setConversationModal = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(),
      conversationUniqueId = _useState3[0],
      setConversationUniqueId = _useState3[1]; // Validation schema


  var validationSchema = yup__WEBPACK_IMPORTED_MODULE_6__/* .object */ .Ry().shape({
    email: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().email().required("Select an email"),
    message: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().required("Write Message").typeError("Write Message"),
    subject: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().required("Write something in subject box")
  });

  var handleClose = function handleClose(event, reason) {
    if (reason && reason == "backdropClick") return;
    setConversationModal(false);
  }; // draft mail


  var handleDraftMail = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
      var payload;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              payload = {
                message: values.message,
                receiverEmail: values.email,
                subject: values.subject,
                parentMessageId: 0
              };

              if (!(values.subject && values.email)) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/student/conversation/conversation/draft/".concat(conversationUniqueId), payload).then(function (res) {
                if (!res.error) {}
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleDraftMail(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var storeMail = /*#__PURE__*/function () {
    var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(values) {
      var payload;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setConLoading(true);
              payload = {
                message: values.message,
                receiverEmail: values.email,
                subject: values.subject,
                parentMessageId: 0
              };

              if (!(values.subject && values.email)) {
                _context4.next = 5;
                break;
              }

              _context4.next = 5;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/student/conversation/conversation/draft/".concat(conversationUniqueId), payload).then( /*#__PURE__*/function () {
                var _ref4 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(res) {
                  var _payload;

                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!(!res.error && res.statusCode === 201)) {
                            _context3.next = 7;
                            break;
                          }

                          _payload = {
                            message: values.message,
                            receiverEmail: values.email,
                            subject: values.subject,
                            parentMessageId: 0
                          };
                          _context3.next = 4;
                          return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/student/conversation/conversation/send/".concat(conversationUniqueId), _payload).then( /*#__PURE__*/function () {
                            var _ref5 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(res) {
                              return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
                                while (1) {
                                  switch (_context2.prev = _context2.next) {
                                    case 0:
                                      if (!res.error) {
                                        (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_7__/* .swalSuccess */ .Xt)("Email Sent");
                                        setConLoading(false);
                                        setConversationModal(false);
                                      } else if (res.error && res.message) {
                                        (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_7__/* .swalError */ .Kj)(res.message);
                                        setConLoading(false);
                                      } else {
                                        (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_7__/* .swalError */ .Kj)("something went wrong");
                                        setConLoading(false);
                                      }

                                    case 1:
                                    case "end":
                                      return _context2.stop();
                                  }
                                }
                              }, _callee2);
                            }));

                            return function (_x4) {
                              return _ref5.apply(this, arguments);
                            };
                          }());

                        case 4:
                          setConLoading(false);
                          _context3.next = 8;
                          break;

                        case 7:
                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_7__/* .swalError */ .Kj)(res.message);

                        case 8:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function storeMail(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var renderComponent = function renderComponent() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().connect_wrapper), "  relative"),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_12__/* .IoMdMail */ .JwT, {
        onClick: function onClick() {
          setConversationModal(true);
          setConversationUniqueId((0,uuid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)());
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: "uni-tooltip",
        children: "Conversation"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        open: conversationModal,
        onClose: handleClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z,
        BackdropProps: {
          timeout: 500
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: "modal md",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "modal_head",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h4", {
              className: "modal_title",
              children: "New Mail"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("button", {
              className: "cross_icon",
              onClick: function onClick() {
                setConversationModal(false);
                setConversationUniqueId();
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_16__/* .FiX */ .q5L, {})
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
            className: "modal_body",
            style: {
              padding: "20px"
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Formik */ .J9, {
              initialValues: {
                email: email,
                subject: "",
                message: "",
                parentMessageId: 0
              },
              enableReinitialize: true,
              validationSchema: validationSchema,
              onSubmit: function onSubmit(values) {
                storeMail(values);
              },
              children: function children(_ref6) {
                var handleSubmit = _ref6.handleSubmit,
                    setFieldValue = _ref6.setFieldValue,
                    values = _ref6.values,
                    errors = _ref6.errors,
                    touched = _ref6.touched;
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Form */ .l0, {
                  className: "form",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                    className: "admin_drawer_container",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                      className: "admin_drawer_body_outer",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                        className: "admin_drawer_body",
                        style: {
                          height: "100%"
                        },
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                          className: (_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().reply_box_wrapper),
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                            className: "reply_box",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                              className: (_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().reply_box_to),
                              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                                children: "To"
                              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                                className: "reply_box_subject ".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().reply_box_subject)),
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                                  className: "admin_form_group",
                                  style: {
                                    marginBottom: "0px"
                                  },
                                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("input", {
                                    style: {
                                      borderRadius: "0",
                                      border: "0"
                                    },
                                    type: "email",
                                    disabled: true,
                                    className: errors.email && touched.email ? "admin_input error_box" : "admin_input",
                                    placeholder: errors.email && touched.email ? errors.email : "Write a user email",
                                    onChange: function onChange(e) {
                                      handleChange(e.target.value);
                                      setFieldValue("email", e.target.value);
                                    },
                                    value: values.email ? values.email : ""
                                  })
                                })
                              })]
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                              className: "reply_box_subject ".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().reply_box_subject)),
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                                className: "admin_form_group",
                                style: {
                                  marginBottom: "0px"
                                },
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("input", {
                                  style: {
                                    borderRadius: "0",
                                    borderLeft: "0",
                                    borderRight: "0"
                                  },
                                  onBlur: function onBlur(e) {
                                    handleDraftMail(values);
                                  },
                                  type: "text",
                                  className: errors.subject && touched.subject ? "admin_input error_box" : "admin_input",
                                  placeholder: errors.subject && touched.subject ? errors.subject : "Write a subject line",
                                  onChange: function onChange(e) {
                                    setFieldValue("subject", e.target.value);
                                  },
                                  value: values.subject ? values.subject : ""
                                })
                              })
                            })]
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                            className: "reply_box_texteditor",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_unisearch_common_form__WEBPACK_IMPORTED_MODULE_1__/* .UniEditorSmall */ .sk, {
                              onChange: function onChange(e) {
                                setFieldValue("message", e.target.value);
                              },
                              contents: values.message ? values.message : "",
                              onBlur: function onBlur(e) {
                                handleDraftMail(values);
                              }
                            })
                          })]
                        }), errors.message && touched.message && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                          className: "invalid-feedback",
                          children: errors.message
                        })]
                      })
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                    className: "modal_footer",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                      className: "btn_group ".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btn_group)),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("button", {
                        className: "btn btn-cancel btn btn-md",
                        onClick: function onClick() {
                          setConversationModal(false);
                          setConversationUniqueId();
                        },
                        children: "Cancel"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("button", {
                        onClick: handleSubmit,
                        type: "submit",
                        className: "btn btn-secondary btn-md",
                        children: [conLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                          size: "16px",
                          color: "inherit"
                        }), "Send"]
                      })]
                    })
                  })]
                });
              }
            })
          })]
        })
      })]
    });
  };

  if (true) {
    return renderComponent();
  } else {}
};
/* harmony default export */ __webpack_exports__["Z"] = (ConversationAction);

/***/ }),

/***/ 3095:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"page_info___next__KpAYC","short_info":"page_info_short_info__2CVJV","info_item":"page_info_info_item__PvuOa","icon":"page_info_icon__TsLci","author":"page_info_author__pq2Y3","text":"page_info_text__cqeYo","name":"page_info_name__tcb28","desc":"page_info_desc__aF06O"};

/***/ }),

/***/ 30890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"play_btn":"play_btn_with_ripple_play_btn__yNA0_","arrow_right":"play_btn_with_ripple_arrow_right__Fmzao","ripple_effect":"play_btn_with_ripple_ripple_effect__4Jxcn","ModalRipple":"play_btn_with_ripple_ModalRipple__5yAi9","medium":"play_btn_with_ripple_medium__ClXl0","small":"play_btn_with_ripple_small__EszEQ","orange":"play_btn_with_ripple_orange__1q96e"};

/***/ }),

/***/ 76300:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"social_links_wrapper":"social_links_social_links_wrapper__k2gOD"};

/***/ }),

/***/ 71285:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uni_rank_card":"top_rank_uni_card_uni_rank_card__FhfuD","uni_image_wrapper":"top_rank_uni_card_uni_image_wrapper__rLU4z","favorite_wrapper":"top_rank_uni_card_favorite_wrapper__DFWw4","uni_card_top":"top_rank_uni_card_uni_card_top__ENT_z","uni_rank":"top_rank_uni_card_uni_rank__icLc_","uni_card_bottom":"top_rank_uni_card_uni_card_bottom__O_y3c","uni_logo_wrapper":"top_rank_uni_card_uni_logo_wrapper__vruFJ","uni_name":"top_rank_uni_card_uni_name__yRzcW","uni_address":"top_rank_uni_card_uni_address__UfAg_","uni_course_link_wrapper":"top_rank_uni_card_uni_course_link_wrapper__4O6KO","btn_popular_course":"top_rank_uni_card_btn_popular_course__k_GKr","uni_course_link":"top_rank_uni_card_uni_course_link__Zxvol","uni_desc":"top_rank_uni_card_uni_desc__hFfZx","uni_ranking_wrapper":"top_rank_uni_card_uni_ranking_wrapper__hzaKE","ranking_title":"top_rank_uni_card_ranking_title__KKvcJ","footer_btn_wrapper":"top_rank_uni_card_footer_btn_wrapper__bkWnl","btn_follow":"top_rank_uni_card_btn_follow__6kpyL","download_link":"top_rank_uni_card_download_link__2IGXs","popular_course_dropdown":"top_rank_uni_card_popular_course_dropdown__TgHt_","popular_course_dropdown_wrapper":"top_rank_uni_card_popular_course_dropdown_wrapper__Fxv7p","dropdown_heading_wrapper":"top_rank_uni_card_dropdown_heading_wrapper__qP04H","dropdown_body_wrapper":"top_rank_uni_card_dropdown_body_wrapper__XVBNC","body_heading":"top_rank_uni_card_body_heading__9_Q_4","course_level":"top_rank_uni_card_course_level__vpQMV","course_name":"top_rank_uni_card_course_name__GpKQw","action_btn":"top_rank_uni_card_action_btn__Fr0UP"};

/***/ }),

/***/ 58982:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"study_banner___next__WYVpN","section_study_banner":"study_banner_section_study_banner__iWl7l","hero_wrapper":"study_banner_hero_wrapper__xtqP_","hero_content":"study_banner_hero_content__Pa6kW","heading":"study_banner_heading__5rMcY","description":"study_banner_description__0Nxbe","sub_heading":"study_banner_sub_heading__AwPLq","breadcrumbs":"study_banner_breadcrumbs___KbvC","active":"study_banner_active__a2RHq","image_wrapper":"study_banner_image_wrapper__B_dfe","featured_image":"study_banner_featured_image__NoBka","bg_soft":"study_banner_bg_soft__q9v8b","oval_square":"study_banner_oval_square__Jhd9F","button_wrapper":"study_banner_button_wrapper__5qP8P","short_info_desktop":"study_banner_short_info_desktop__S59iL","short_info_mobile":"study_banner_short_info_mobile__Ygp3J"};

/***/ }),

/***/ 42817:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"study_banner_two___next__MKU4X","section_study_banner":"study_banner_two_section_study_banner__R83L5","hero_container":"study_banner_two_hero_container__iOc6t","sub_heading":"study_banner_two_sub_heading__4zqNf","description":"study_banner_two_description__lbHQN","breadcrumbs":"study_banner_two_breadcrumbs__gqSc4","active":"study_banner_two_active___8CoC","short_info":"study_banner_two_short_info__w_iaj","info_item":"study_banner_two_info_item__guaea","author":"study_banner_two_author__hasJp","text":"study_banner_two_text__cl0_A","desc":"study_banner_two_desc__rFoti","info_button":"study_banner_two_info_button__cjdhN","short_info_desktop":"study_banner_two_short_info_desktop__GAUP1","short_info_mobile":"study_banner_two_short_info_mobile__fYh0v","image_wrapper":"study_banner_two_image_wrapper__vV7pl","oval_square":"study_banner_two_oval_square__BUqHF"};

/***/ }),

/***/ 52885:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"study_links___next__1DkBi","section_links":"study_links_section_links__wc_lm","links_wrapper":"study_links_links_wrapper__tf0wu","links_container":"study_links_links_container__0EBHn","active":"study_links_active__PrSVp","social_link_wrapper":"study_links_social_link_wrapper__ob7b_"};

/***/ }),

/***/ 68337:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"study_admission_requirement_wrapper__S3yB4","heading_wrapper":"study_admission_requirement_heading_wrapper__IWGCP","requirement_lists":"study_admission_requirement_requirement_lists___e5sc","icon_wrapper":"study_admission_requirement_icon_wrapper__RFQwb","desc":"study_admission_requirement_desc__rgeph"};

/***/ }),

/***/ 20639:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"study_admission_session_title__hRqFA","admission_session_wrapper":"study_admission_session_admission_session_wrapper__SBI3J","admission_tooltip":"study_admission_session_admission_tooltip__RUoek","line":"study_admission_session_line__qlAMN","icon_wrapper":"study_admission_session_icon_wrapper__7fyaA","icon_image_wrapper":"study_admission_session_icon_image_wrapper__rWzUX","green":"study_admission_session_green__x3TKm","violet":"study_admission_session_violet__NET2Z","blue":"study_admission_session_blue__K8R_y","pink":"study_admission_session_pink__nC9ub","orange":"study_admission_session_orange__e7eXz","admission_text":"study_admission_session_admission_text__Losdn"};

/***/ }),

/***/ 62206:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"study_overview_about___next__mYjqT","about":"study_overview_about_about__mdbgQ","about_image":"study_overview_about_about_image__EaXrn","about_facts":"study_overview_about_about_facts__5qWx6","first":"study_overview_about_first__gUwh5","last":"study_overview_about_last__8MLGJ","btn_wrapper":"study_overview_about_btn_wrapper__Nn_WS","about_button":"study_overview_about_about_button__NySe0","about_icon":"study_overview_about_about_icon__DT_jF","about_button_text":"study_overview_about_about_button_text__8zws6","child":"study_overview_about_child__oou56","country_description":"study_overview_about_country_description__Qr64L","heading":"study_overview_about_heading__fx2tT","button_wrapper":"study_overview_about_button_wrapper__bgr7r"};

/***/ }),

/***/ 80512:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading":"study_post_admission_heading__XQwaF","post_admission_wrapper":"study_post_admission_post_admission_wrapper__CdiJ0","half_wheel_icon":"study_post_admission_half_wheel_icon__cTJyK","sub_title":"study_post_admission_sub_title___m5El","card_wrapper":"study_post_admission_card_wrapper__uwfrJ","card_title":"study_post_admission_card_title__drD3i","quick_info_wrapper":"study_post_admission_quick_info_wrapper___qF49","card_description":"study_post_admission_card_description__ezpqT","costof_living_wrapper":"study_post_admission_costof_living_wrapper__zVhLS","low_high_indicator_wrapper":"study_post_admission_low_high_indicator_wrapper__ddQMA","low_high_image_wrapper":"study_post_admission_low_high_image_wrapper__X1xZK","low_high_indicator":"study_post_admission_low_high_indicator__8I2Hs","weather_box_wrapper":"study_post_admission_weather_box_wrapper__BcJgw","weather_heading":"study_post_admission_weather_heading__PEtjd","select_dropdown_wrapper":"study_post_admission_select_dropdown_wrapper__jtX8v","weather_list":"study_post_admission_weather_list__kQ1yE","city":"study_post_admission_city__K8Ieb","temperature":"study_post_admission_temperature__eYVEm","living_cost_wrapper":"study_post_admission_living_cost_wrapper__B9m3B","living_cost_list":"study_post_admission_living_cost_list__0OI9M","cost_image":"study_post_admission_cost_image__5pZII","cost_title":"study_post_admission_cost_title__x9Mx6","cost_range":"study_post_admission_cost_range__qXYF9","visa_option":"study_post_admission_visa_option___iyPX"};

/***/ }),

/***/ 71921:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"specialization_wrapper":"study_specialization_specialization_wrapper__5G30f","icon_wrapper":"study_specialization_icon_wrapper__XXuoK","icon_image_wrapper":"study_specialization_icon_image_wrapper__6zOKp","specialization_name":"study_specialization_specialization_name__wb8Nv","field_of_study_wrapper":"study_specialization_field_of_study_wrapper__MfsoG","field_study_title":"study_specialization_field_study_title__ZBq3y","wrapper":"study_specialization_wrapper__Xnw6G"};

/***/ }),

/***/ 84908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_top_rank":"study_top_rank_two_section_top_rank__KMAHT","wrapper":"study_top_rank_two_wrapper__GEwxJ","title_wrapper":"study_top_rank_two_title_wrapper__rXF1z"};

/***/ }),

/***/ 25850:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_study_video":"study_video_section_study_video__9afad","study_video_wrapper":"study_video_study_video_wrapper__67lH7","video_area":"study_video_video_area__Nrsx_","overlay":"study_video_overlay__0uzjM"};

/***/ }),

/***/ 47384:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"uni_thumb_grid_box___next__PWbmq","box":"uni_thumb_grid_box_box__W9voa","image_wrapper":"uni_thumb_grid_box_image_wrapper__AWQY2","banner":"uni_thumb_grid_box_banner__Zf_6n","logo_wrapper":"uni_thumb_grid_box_logo_wrapper__Cp3oL","logo":"uni_thumb_grid_box_logo__RM_tL","profile_box_content":"uni_thumb_grid_box_profile_box_content__gak3t","infos":"uni_thumb_grid_box_infos__fPlcm","name":"uni_thumb_grid_box_name__MElzQ","info":"uni_thumb_grid_box_info__WO_dQ","icon":"uni_thumb_grid_box_icon__Pqn4E","follow":"uni_thumb_grid_box_follow__PN7Lc","links":"uni_thumb_grid_box_links__AhukV","popular_courses":"uni_thumb_grid_box_popular_courses__JISnW","first":"uni_thumb_grid_box_first__snPsV","last":"uni_thumb_grid_box_last__apQqX","all_courses":"uni_thumb_grid_box_all_courses__KKNUC"};

/***/ }),

/***/ 42891:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"message_component_wrapper":"message_message_component_wrapper__1ieyP","buddy_msg_wrapper":"message_buddy_msg_wrapper__DK00E","msg_time":"message_msg_time__pkHde","msg_wrapper":"message_msg_wrapper__bcN0z","image_wrapper":"message_image_wrapper__75POr","replymsg":"message_replymsg__Q1uk8","my_msg_time":"message_my_msg_time__RxJqO","my_msg":"message_my_msg__0MTvI","mark":"message_mark__3uB3z","heading":"message_heading__nN8Pc","details_wrapper":"message_details_wrapper__KVYfo","msg_footer_wrapper":"message_msg_footer_wrapper__S9kxU","action":"message_action__0Olen","left":"message_left__1Zl0o","action_btn":"message_action_btn__l9bDv","conversation_wrapper":"message_conversation_wrapper__YdB1H","conversation_wrapper_child":"message_conversation_wrapper_child__50fY7","details_wrapper2":"message_details_wrapper2__mMBhj","empty_detail_wrapper":"message_empty_detail_wrapper__SuI8J","my_msg_wrapper":"message_my_msg_wrapper__PTorz","heading_menu":"message_heading_menu__Kqe7o"};

/***/ }),

/***/ 6867:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"active_chatt_box":"list_active_chatt_box__MbZyB","chatt":"list_chatt__Y9S5q","time":"list_time__brnw_","image_wrapper":"list_image_wrapper__waMIN","active_chatt_box_modal":"list_active_chatt_box_modal___BrsY","chatt_box":"list_chatt_box__GiEyE","chatt_msg":"list_chatt_msg__KF_sP","chatt_box_wrapper":"list_chatt_box_wrapper__4qk6k","list_wrapper":"list_list_wrapper__DX7IH","search_input":"list_search_input__2YMvn","search_icon":"list_search_icon__3ZZ8U","header_wrapper":"list_header_wrapper__elCsP","btn_group":"list_btn_group__POPeU","search_input_modal":"list_search_input_modal___ZcDT","modal_body":"list_modal_body__nHnG8","no_found":"list_no_found__wMd8W","btn_close":"list_btn_close__2T9Vb","btn_add_user":"list_btn_add_user__9cjH4","btn_plus":"list_btn_plus__B7L_4"};

/***/ }),

/***/ 53913:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"favourite_wrapper":"actions_favourite_wrapper__mmZgl","icon_heart":"actions_icon_heart__MtTT3","selected":"actions_selected__bf0TV","icon_swap":"actions_icon_swap__irRwk","compare_wrapper":"actions_compare_wrapper__z_sdX","bookmarke_wrapper":"actions_bookmarke_wrapper__31rzO","btn_bookmark":"actions_btn_bookmark__pq8QI","active":"actions_active__vtMRT","icon_spin":"actions_icon_spin__z5nco","spin":"actions_spin__kUes6","connect_wrapper":"actions_connect_wrapper__ESCJU","reply_box_wrapper":"actions_reply_box_wrapper__AVnAn","reply_box_to":"actions_reply_box_to__rmbnD","reply_box_subject":"actions_reply_box_subject__CBp2A","reply_box_actions":"actions_reply_box_actions__GBlrl","reply_box_action_right":"actions_reply_box_action_right__4oLns"};

/***/ }),

/***/ 73873:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 41548:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ })

}]);